function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { InfaceEnv, SDKError, getModuleApi, generateUUID, WSClient, lodash, InfaceSDK } from '@inface-sdk/common';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/**
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @namespace LS_ENUM
 * @description 라이브스트림 SDK 기본값 constant
 */
var _LS_ENUM = {
  SUCCESS: 'success',
  FAIL: 'fail',
  MODULE_NAME: 'livestream',
  MODULE_NAME_ABB: 'ls',
  //abbreviation
  IM_GAME: 'im-game',
  ERROR: 'error',
  SUB_ERROR: 'sub_error',
  INTERFACE: {
    INITIALIZE: 'initialize',
    ADD_GID: 'add_gid',
    ATTACH_AUTH: 'attach_auth',
    FINALIZE: 'finalize',
    PROTOBUF: 'protobuf',
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    ADD_EVENT_LISTENER: 'add_event_listener',
    REMOVE_EVENT_LISTENER: 'remove_event_listener'
  },
  STATUS: {
    LIST: ['stop', 'standby', 'start'],
    STOP: 'stop',
    STANDBY: 'standby',
    START: 'start'
  },
  SDK_BRIDGE_TIMEOUT: 5 * 60 * 1000,
  // 5분 (inface sdk IPC 통신 bridge timeout)
  CHECK_CID_TIMEOUT_SECOND: 1 * 1000,
  // 5초
  CHECK_CID_TIMEOUT_SECOND_MAX: 5 * 1000,
  // 5초
  BINARY_BACK_OFF_MAX_TIME: 30 * 60 * 1000,
  // 30분
  BINARY_BACK_OFF_INTERVAL_TIME: 5 * 1000,
  // 5초
  REQUEST_TIMEOUT_SECOND_MAX: 5 * 1000,
  // 5초
  REQUEST_COUNT_MAX: 5,
  PING_INTERVAL_TIME: 3 * 60 * 1000,
  // 3분
  PING_TIMEOUT: 5 * 1000 // PING_INTERVAL_TIME + 5초 (마지막 핑을 보낸 이후 5초 초과이후까지 pong이 도착하지 않으면 타임아웃)
};
var LS_ENUM$1 = _LS_ENUM;

/**
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @namespace WS_ENUM
 * @description 소켓박스 기본값 constant
 */
var _WS_ENUM = {
  STATUS: {
    STANDBY: 'standby',
    ACTIVE: 'active'
  },
  KEY: {
    TYPE: 'ls_action',
    BODY: 'ls_data',
    META: 'ls_meta',
    CLIENT_REQUEST_TIME: 'c_req',
    SERVER_REQUEST_TIME: 's_req',
    SERVER_RESPONSE_TIME: 's_res',
    ERROR: 'ls_error',
    ERROR_NAME: 'name',
    ERROR_MESSAGE: 'message',
    ERROR_STACK: 'stack',
    ERROR_DATA: 'data'
  },
  EVENT: {
    CONNECT: 'ls::connect',
    NEGOTIATION: 'ls::connect_negotiation',
    CREATE_UTOKEN: 'ls::create_utoken',
    AUTH: 'ls::auth',
    ADD_GID_BY_WEB_TOKEN: 'ls::add_guid_by_web_token',
    PROTOBUF: 'ls::protobuf',
    MAINTENANCE: 'ls::maintenance',
    SUBSCRIBE: 'subscribe',
    UNSUBSCRIBE: 'unsubscribe',
    SUBSCRIBE_WITH_SUFFIX: 'subscribe_with_suffix',
    UNSUBSCRIBE_WITH_SUFFIX: 'unsubscribe_with_suffix',
    DISCONNECT: 'disconnect',
    WS_CONNECT: 'ws::connect',
    WS_RECONNECT: 'ws::reconnect',
    WS_DISCONNECT: 'ws::disconnect',
    WS_MESSAGE: 'ws::message',
    WS_PING: 'ws::ping',
    WS_PING_TIMEOUT: 'ws::ping_timeout',
    WS_PONG: 'ws::pong',
    WS_ERROR: 'ws::error'
  },
  ACTION_SEPARATOR: '::',
  PROTOCOL_VERSION_LATEST: '2.5',
  PROTOCOL_VERSION_DEFAULT: '2.4',
  PROTOCOL_VERSION: 'protocol_version',
  SDK_VERSION: 'sdk_version',
  SDK_PLATFORM: 'sdk_platform',
  SDK_TYPE: 'sdk_type',
  CID: 'cid',
  HWID: 'hwid',
  SDK_TYPE_DESKTOP: 'desktop'
};
var WS_ENUM$1 = _WS_ENUM;

/**
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @namespace ENV
 * @description 라이브스트림 SDK NODE ENV constant
 */

var _ENV = {
  LOCAL: 'local',
  DEV: 'dev',
  TEST: 'test',
  LIVE: 'live'
};
_ENV.LIST = [_ENV.LOCAL, _ENV.DEV, _ENV.TEST, _ENV.LIVE];
_ENV.LIVE_STREAM_VERSION = function (_ref6) {
  var _ref6$env = _ref6.env,
    _env = _ref6$env === void 0 ? InfaceEnv.value.env || _ENV.LIVE : _ref6$env;
  return (process.env.__livestream_sdk_version || '__livestream_sdk_version') + (_env ? "-".concat(_env) : '');
};
_ENV.URL = function (_ref7) {
  var _ref7$env = _ref7.env,
    _env2 = _ref7$env === void 0 ? InfaceEnv.value.env || _ENV.LIVE : _ref7$env;
  switch (_env2) {
    case _ENV.LOCAL:
      return 'ws://localhost:8080/connect';
    case _ENV.DEV:
      return 'wss://dev-livestream.inface.nexon.com/connect';
    case _ENV.TEST:
      return 'wss://test-livestream.inface.nexon.com/connect';
    default:
    case _ENV.LIVE:
      return 'wss://livestream.inface.nexon.com/connect';
  }
};
var ENV$1 = _ENV;

/**
 * @namespace LS_ERR
 *
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @description 라이브스트림 SDK 에러 관리 constant

 * @property {JSON} FAILED_INIT {CODE: 111001, MESSAGE: 'Failed to start sdk.'}
 * @property {JSON} FAILED_INIT_PROCESS {CODE: 111002, MESSAGE: 'Operation failed during the sdk startup process.'}
 * @property {JSON} FAILED_INIT_WS {CODE: 111003, MESSAGE: 'Websocket initialization failed.'}
 * @property {JSON} FAILED_CONNECT_WS {CODE: 111004, MESSAGE: 'Connection between sdk and websocket failed.'}
 * @property {JSON} FAILED_DISCONNECT_WS {CODE: 111005, MESSAGE: 'Failed to disconnect.'}
 * @property {JSON} FAILED_CREATE_UTOKEN {CODE: 111006, MESSAGE: 'utoken creation failed.'}
 * @property {JSON} FAILED_AUTH_TO_SERVER {CODE: 111007, MESSAGE: 'Account authentication to the server failed.'}
 * @property {JSON} FAILED_SUBSCRIBE {CODE: 111008, MESSAGE: 'Failed to subscribe to the event.'}
 * @property {JSON} FAILED_UNSUBSCRIBE {CODE: 111009, MESSAGE: 'Failed to unsubscribe to the event.'}
 * @property {JSON} FAILED_EMIT {CODE: 111011, MESSAGE: 'Failed to emit.'}
 * @property {JSON} FAILED_FIN {CODE: 111012, MESSAGE: 'Failed to finalize sdk.'}
 * @property {JSON} FAILED_FIN_PROCESS {CODE: 111013, MESSAGE: 'Operation failed during the sdk finalize process.'}
 * @property {JSON} FAILED_PROTOBUF {CODE: 111014, MESSAGE: 'Failed to protobuf.'}
 * @property {JSON} FAILED_GET_PAYLOAD {CODE: 111015, MESSAGE: 'Failed get payload from server.'}
 * @property {JSON} FAILED_ADD_EVENT_LISTENER {CODE: 111016, MESSAGE: 'Failed to add event listerner.'}
 * @property {JSON} FAILED_GET_LISTENER {CODE: 111017, MESSAGE: 'Failed to get listerner object in instance.'}
 * @property {JSON} FAILED_AUTH {CODE: 111018, MESSAGE: 'Failed to auth.'}
 * @property {JSON} FAILED_ADD_EVENT_LISTENER_FROM_SERVER {CODE: 111019, MESSAGE: 'Failed to add event listerner from server.'}
 * @property {JSON} FAILED_GET_CID {CODE: 111020, MESSAGE: 'Failed to get cid value from server.'}
 * @property {JSON} FAILED_ADD_GID {CODE: 111021, MESSAGE: 'Failed to add gid value from server.'}
 * @property {JSON} INVALID_LOOP_TIME {CODE: 111101, MESSAGE: 'Invalid loopTime value.'}
 * @property {JSON} INVALID_PATH {CODE: 111102, MESSAGE: 'Invalid path value.'}
 * @property {JSON} INVALID_PATH_SUFFIX {CODE: 111103, MESSAGE: 'Invalid path suffix value.'}
 * @property {JSON} INVALID_ACCESS_TOKEN {CODE: 111104, MESSAGE: 'Invalid access token.'}
 * @property {JSON} INVALID_ACCESS_TOKEN_TYPE {CODE: 111105, MESSAGE: 'Invalid access token type.'}
 * @property {JSON} INVALID_TYPE {CODE: 111106, MESSAGE: 'Invalid type value.'}
 * @property {JSON} INVALID_PAYLOAD {CODE: 111107, MESSAGE: 'Invalid payload value.'}
 * @property {JSON} INVALID_UTOKEN {CODE: 111108, MESSAGE: 'Invalid utoken value.'}
 * @property {JSON} INVALID_GID {CODE: 111109, MESSAGE: 'Invalid gid value.'}
 * @property {JSON} INVALID_WEB_TOKEN {CODE: 111110, MESSAGE: 'Invalid web token value.'}
 * @property {JSON} DUPLICATED_INITIALIZE {CODE: 111201, MESSAGE: 'The SDK has already started the initialization process.'}
 * @property {JSON} TRANSITION_SERVER {CODE: 111202, MESSAGE: 'LS server  is currently undergoing a transition.'}
 * @property {JSON} SDK_DID_NOT_START {CODE: 111203, MESSAGE: 'The SDK must be started first.'}
 * @property {JSON} SERVER_ERROR {CODE: 111204, MESSAGE: 'An error occurred on the server.'}
 * @property {JSON} SERVER_RESPONSE_UNDEFINED_DATA_ERROR {CODE: 111205, MESSAGE: 'Undefined server response data.'}
 * @property {JSON} UNKNOWN_ERROR {CODE: 111206, MESSAGE: 'Unknown error occured.'}
 * @property {JSON} SERVER_RESPONSE_TIMEOUT {CODE: 111207, MESSAGE: 'Server response timed out.'}
 * @property {JSON} DUPLICATED_REQUEST {CODE: 111208, MESSAGE: 'Duplicate request with same payload.'}
*/
var _LS_ERR = {
  FAILED_INIT: {
    CODE: 111001,
    MESSAGE: 'Failed to start sdk.'
  },
  FAILED_INIT_PROCESS: {
    CODE: 111002,
    MESSAGE: 'Operation failed during the sdk startup process.'
  },
  FAILED_INIT_WS: {
    CODE: 111003,
    MESSAGE: 'Websocket initialization failed.'
  },
  FAILED_CONNECT_WS: {
    CODE: 111004,
    MESSAGE: 'Connection between sdk and websocket failed.'
  },
  FAILED_DISCONNECT_WS: {
    CODE: 111005,
    MESSAGE: 'Failed to disconnect.'
  },
  FAILED_CREATE_UTOKEN: {
    CODE: 111006,
    MESSAGE: 'utoken creation failed.'
  },
  FAILED_AUTH_TO_SERVER: {
    CODE: 111007,
    MESSAGE: 'Account authentication to the server failed.'
  },
  FAILED_SUBSCRIBE: {
    CODE: 111008,
    MESSAGE: 'Failed to subscribe to the event.'
  },
  FAILED_UNSUBSCRIBE: {
    CODE: 111009,
    MESSAGE: 'Failed to unsubscribe to the event.'
  },
  FAILED_EMIT: {
    CODE: 111011,
    MESSAGE: 'Failed to emit.'
  },
  FAILED_FIN: {
    CODE: 111012,
    MESSAGE: 'Failed to finalize sdk.'
  },
  FAILED_FIN_PROCESS: {
    CODE: 111013,
    MESSAGE: 'Operation failed during the sdk finalize process.'
  },
  FAILED_PROTOBUF: {
    CODE: 111014,
    MESSAGE: 'Failed to protobuf.'
  },
  FAILED_GET_PAYLOAD: {
    CODE: 111015,
    MESSAGE: 'Failed get payload from server.'
  },
  FAILED_ADD_EVENT_LISTENER: {
    CODE: 111016,
    MESSAGE: 'Failed to add event listerner.'
  },
  FAILED_GET_LISTENER: {
    CODE: 111017,
    MESSAGE: 'Failed to get listerner object in instance.'
  },
  FAILED_AUTH: {
    CODE: 111018,
    MESSAGE: 'Failed to auth.'
  },
  FAILED_ADD_EVENT_LISTENER_FROM_SERVER: {
    CODE: 111019,
    MESSAGE: 'Failed to add event listerner from server.'
  },
  FAILED_GET_CID: {
    CODE: 111020,
    MESSAGE: 'Failed to get cid value from server.'
  },
  FAILED_ADD_GID: {
    CODE: 111021,
    MESSAGE: 'Failed to add gid from server.'
  },
  INVALID_LOOP_TIME: {
    CODE: 111101,
    MESSAGE: 'Invalid loopTime value.'
  },
  INVALID_PATH: {
    CODE: 111102,
    MESSAGE: 'Invalid path value.'
  },
  INVALID_PATH_SUFFIX: {
    CODE: 111103,
    MESSAGE: 'Invalid path suffix value.'
  },
  INVALID_ACCESS_TOKEN: {
    CODE: 111104,
    MESSAGE: 'Invalid access token.'
  },
  INVALID_ACCESS_TOKEN_TYPE: {
    CODE: 111105,
    MESSAGE: 'Invalid access token type.'
  },
  INVALID_TYPE: {
    CODE: 111106,
    MESSAGE: 'Invalid type value.'
  },
  INVALID_PAYLOAD: {
    CODE: 111107,
    MESSAGE: 'Invalid payload value.'
  },
  INVALID_UTOKEN: {
    CODE: 111108,
    MESSAGE: 'Invalid utoken value.'
  },
  INVALID_GID: {
    CODE: 111109,
    MESSAGE: 'Invalid gid value.'
  },
  INVALID_WEB_TOKEN: {
    CODE: 111110,
    MESSAGE: 'Invalid web token value.'
  },
  DUPLICATED_INITIALIZE: {
    CODE: 111201,
    MESSAGE: 'The SDK has already started the initialization process.'
  },
  TRANSITION_SERVER: {
    CODE: 111202,
    MESSAGE: 'LS server  is currently undergoing a transition.'
  },
  SDK_DID_NOT_START: {
    CODE: 111203,
    MESSAGE: 'The SDK must be started first.'
  },
  SERVER_ERROR: {
    CODE: 111204,
    MESSAGE: 'An error occurred on the server.'
  },
  SERVER_RESPONSE_UNDEFINED_DATA_ERROR: {
    CODE: 111205,
    MESSAGE: 'Undefined server response data.'
  },
  UNKNOWN_ERROR: {
    CODE: 111206,
    MESSAGE: 'Unknown error occured.'
  },
  SERVER_RESPONSE_TIMEOUT: {
    CODE: 111207,
    MESSAGE: 'Server response timed out.'
  },
  DUPLICATED_REQUEST: {
    CODE: 111208,
    MESSAGE: 'Duplicate request with same payload.'
  }
};
_LS_ERR = Object.freeze(Object.assign({}, _LS_ERR));
for (var _i = 0, _Object$values = Object.values(_LS_ERR); _i < _Object$values.length; _i++) {
  var prop = _Object$values[_i];
  Object.freeze(prop);
}
var LS_ERR$1 = _LS_ERR;

/**
 * @namespace DEBUG
 *
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @description 라이브스트림 SDK 디버그 모드
 * @property {string} USE 디버그 사용 유무
 * @property {number} LEVEL 디버그 레벨 (1: 모듈 상태 로깅, 2: 에러 로깅, 3: 서버 통신 로깅)
 * @property {number} MAX_LEVEL 디버그 최대 레벨
 * @property {number} MIN_LEVEL 디버그 최소 레벨
 * @property {function} STANDBY 모듈 STANDBY 로깅
 * @property {function} START 모듈 START 로깅
 * @property {function} STOP 모듈 STOP 로깅
 * @property {function} LOG 모든 이벤트 로깅
 * @property {function} ERROR 에러 로깅
 */

var DEBUG$1 = {
  USE: false,
  LEVEL: 1,
  MAX_LEVEL: 3,
  MIN_LEVEL: 1,
  status: function status(name, payload) {
    if (!DEBUG$1.USE || DEBUG$1.USE === 'false') return false;
    switch (name) {
      case 'stop':
        break;
      case 'standby':
        break;
      case 'start':
        break;
    }
  },
  log: function log(_log) {
    if (DEBUG$1.USE && DEBUG$1.LEVEL === DEBUG$1.MAX_LEVEL) {
      for (var _len = arguments.length, message = new Array(_len > 1 ? _len - 1 : 0), _key2 = 1; _key2 < _len; _key2++) {
        message[_key2 - 1] = arguments[_key2];
      }
    }
  },
  error: function error(_error2) {
    var _console;
    for (var _len2 = arguments.length, message = new Array(_len2 > 1 ? _len2 - 1 : 0), _key3 = 1; _key3 < _len2; _key3++) {
      message[_key3 - 1] = arguments[_key3];
    }
    (_console = console).error.apply(_console, ['ERROR:', _error2].concat(message));
  }
};
var LS_ENUM = LS_ENUM$1;
var WS_ENUM = WS_ENUM$1;
var ENV = ENV$1;
var LS_ERR = LS_ERR$1;
var DEBUG = DEBUG$1;

/** 라이브스트림 에러 발생
 * @author 박희용
 * @module error
 * @function error/throwLSError
 * @param {Object} [payload] 페이로드
 * @param {Object} name 에러 이름
 * @param {Object} [type] 이벤트 타입
 * @param {Object} [error] SDKError 에러 객체
 * @param {Object} [option] 옵션
 * @param {Object} [option.hide] 로그 숨김
 *  @throws {SDKErrorException}
 */

var throwLSError$1 = function throwLSError$1(_ref8) {
  var payload = _ref8.payload,
    name = _ref8.name,
    type = _ref8.type,
    error = _ref8.error,
    option = _ref8.option;
  if (error && error instanceof SDKError) throw error;
  if (!name || !LS_ERR[name]) return true;
  switch (name) {
    case 'DUPLICATED_INITIALIZE':
      if (payload && payload.status && payload.status === LS_ENUM.STATUS.STOP) return true;
      break;
    case 'INVALID_PATH':
      if (payload && payload.path) return true;
      break;
    case 'INVALID_PATH_SUFFIX':
      if (payload && (!payload.path_suffix || payload.path_suffix && Array.isArray(payload.path_suffix))) return true;
      break;
    case 'INVALID_ACCESS_TOKEN':
      if (payload && payload.accessToken) return true;
      break;
    case 'INVALID_ACCESS_TOKEN_TYPE':
      if (payload && payload.accessTokenType) return true;
      break;
    case 'INVALID_UTOKEN':
      if (payload && payload.utoken) return true;
      break;
    case 'INVALID_PAYLOAD':
      if (payload && payload.bytes) return true;
      break;
    case 'INVALID_GID':
      if (payload && payload.gid) return true;
      break;
    case 'INVALID_WEB_TOKEN':
      if (payload && (payload.web_token || payload.webToken)) return true;
      break;
    case 'SDK_DID_NOT_START':
      if (payload && payload.status && payload.status === LS_ENUM.STATUS.START) return true;
      break;
    case 'SERVER_RESPONSE_UNDEFINED_DATA_ERROR':
      if (payload && payload.type && typeof payload.type === 'string' && payload.body && payload.meta) return true;
      break;
  }
  var errorInstance = new SDKError().failedAction(LS_ERR[name].MESSAGE, LS_ERR[name].CODE, type, {
    payload: payload,
    error: error
  });
  if (!option || option && !option.hide) DEBUG.error(errorInstance);
  throw errorInstance;
};
/** 에러 객체 체크 및 반환
 * @author 박희용
 * @module error
 * @function error/getErrorInstance
 * @param {Object} [data]
 * @param {Object} data.event 이벤트 이름
 * @param {Object} data.payload 페이로드
 * @param {Object} data.name 에러 이름
 * @param {Object} data.error 에러 객체
 * @return {SDKError}
 */

var getErrorInstance$1 = function getErrorInstance$1(data) {
  try {
    var event = data.event,
      _payload = data.payload,
      name = data.name,
      error = data.error;
    var errorInstance = error;
    if (!(error instanceof SDKError)) {
      var errorName = LS_ERR[name || 'UNKNOWN_ERROR'].MESSAGE;
      var errorCode = LS_ERR[name || 'UNKNOWN_ERROR'].CODE;
      errorInstance = new SDKError().failedAction(errorName, errorCode, event, {
        payload: _payload,
        error: error
      });
      DEBUG.error(errorInstance);
    }
    return errorInstance;
  } catch (error) {
    DEBUG.error(error);
    return error;
  }
};

/** LS 서버 웹소켓 통신 에러 모듈
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module error
 * @param {Object} error 서버로 부터 수신한 에러 객체
 * @param {Object} module 라이브스트림 SDK 모듈 참조
 * @param {requestCallback} onFail 게임 클라이언트 인터페이스로 실패 콜백
 */

var socketError$1 = function socketError$1(_ref9) {
  var error = _ref9.error;
  if (error && error.code && Number.isInteger(error.code)) {
    switch (error.code) {
      case 1006:
        // 서버 전송 메시지 max length 초과
        return false;
    }
  }
  return getErrorInstance$1({
    error: error,
    event: WS_ENUM.EVENT.WS_CONNECT,
    name: 'FAILED_CONNECT_WS'
  });
};
var throwLSError = throwLSError$1;
var getErrorInstance = getErrorInstance$1;
var socketError = socketError$1;

/** 게임 클라이언트 ~ 라이브스트림 SDK 인터페이스
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module Livestream
 */

var rawApi = function rawApi(module) {
  return [
  // LS SDK 시작
  {
    name: LS_ENUM.INTERFACE.INITIALIZE,
    /**
     * @function initialize
     * @memberof module:Livestream
     * @param {string} path 디버그 모드 사용
     * @param {string} env 실행 환경
     */
    action: function action(_ref10, payload) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var ok, fail, event, res, errorInstance;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              ok = _ref10.ok, fail = _ref10.fail;
              event = LS_ENUM.INTERFACE.INITIALIZE;
              _context.prev = 2;
              _context.next = 5;
              return module[event](payload);
            case 5:
              res = _context.sent;
              return _context.abrupt("return", ok(_extends({}, res)));
            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](2);
              errorInstance = getErrorInstance({
                event: event,
                name: 'FAILED_INIT',
                payload: payload,
                error: _context.t0
              });
              errorInstance.name = event;
              return _context.abrupt("return", fail(_extends({}, errorInstance)));
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 9]]);
      }))();
    }
  },
  // LS SDK 인증
  {
    name: LS_ENUM.INTERFACE.ATTACH_AUTH,
    /**
     * @function attach_auth
     * @memberof module:Livestream
     * @param {string} access_token 인증 토큰
     * @param {string} access_token_type  인증 토큰 타입
     */
    action: function action(_ref11, payload) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var ok, fail, event, res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              ok = _ref11.ok, fail = _ref11.fail;
              event = LS_ENUM.INTERFACE.ATTACH_AUTH;
              _context2.prev = 2;
              _context2.next = 5;
              return module[event](payload);
            case 5:
              res = _context2.sent;
              return _context2.abrupt("return", ok(_extends({}, res)));
            case 9:
              _context2.prev = 9;
              _context2.t0 = _context2["catch"](2);
              return _context2.abrupt("return", fail(getErrorInstance({
                event: event,
                name: 'FAILED_AUTH',
                payload: payload,
                error: _context2.t0
              })));
            case 12:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[2, 9]]);
      }))();
    }
  },
  // LS SDK 종료
  {
    name: LS_ENUM.INTERFACE.FINALIZE,
    /**
     * @function finalize
     * @memberof module:Livestream
     */
    action: function action(_ref12) {
      var ok = _ref12.ok,
        fail = _ref12.fail;
      var event = LS_ENUM.INTERFACE.FINALIZE;
      try {
        module[event]();
        return ok();
      } catch (error) {
        return fail(getErrorInstance({
          event: event,
          name: 'FAILED_FIN',
          payload: payload,
          error: error
        }));
      }
    }
  },
  // 페이로드 송신
  {
    name: LS_ENUM.INTERFACE.PROTOBUF,
    /**
     * @function protobuf
     * @memberof module:Livestream
     * @ignore
     * @param {Object} args inface-sdk에서 전달 받은 객체
     * @param {requestCallback} args.ok 게임 클라이언트 인터페이스로 성공 콜백
     * @param {requestCallback} args.fail 게임 클라이언트 인터페이스로 실패 콜백
     * @param {Object} payload 게임 클라이언트(호출자)가 전달한 페이로드
     * @param {string} payload.bytes base64 타입의 데이터
     */
    action: function action(_ref13, payload) {
      var ok = _ref13.ok,
        fail = _ref13.fail;
      var event = LS_ENUM.INTERFACE.PROTOBUF;
      try {
        module[event](payload);
        return ok();
      } catch (error) {
        return fail(getErrorInstance({
          event: event,
          name: 'FAILED_PROTOBUF',
          payload: payload,
          error: error
        }));
      }
    }
  },
  // 이벤트 구독
  {
    name: LS_ENUM.INTERFACE.SUBSCRIBE,
    /**
     * @function subscribe
     * @memberof module:Livestream
     * @param {string} path 게임 이름
     * @param {string} stream  대상 스트림 이름
     * @param {string[]} path_suffix 월드(채널) 리스트
     */
    action: function action(_ref14, payload) {
      var ok = _ref14.ok,
        fail = _ref14.fail;
      var event = LS_ENUM.INTERFACE.SUBSCRIBE;
      try {
        module[event](payload);
        return ok();
      } catch (error) {
        return fail(getErrorInstance({
          event: event,
          name: 'FAILED_SUBSCRIBE',
          payload: payload,
          error: error
        }));
      }
    }
  },
  // 이벤트 구독 해제
  {
    name: LS_ENUM.INTERFACE.UNSUBSCRIBE,
    /**
     * @function unsubscribe
     * @memberof module:Livestream
     * @param {string} path 게임 이름
     * @param {string} stream  대상 스트림 이름
     * @param {string[]} path_suffix 월드(채널) 리스트
     */
    action: function action(_ref15, payload) {
      var ok = _ref15.ok,
        fail = _ref15.fail;
      var event = LS_ENUM.INTERFACE.UNSUBSCRIBE;
      try {
        module[event](payload);
        return ok();
      } catch (error) {
        return fail(getErrorInstance({
          event: event,
          name: 'FAILED_UNSUBSCRIBE',
          payload: payload,
          error: error
        }));
      }
    }
  }];
};

/** 라이브스트림 SDK ~ module 서버 프로토콜 통신 인터페이스 모듈
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module connector
 * @param {Object} module LS 모듈
 */
var sdkApi = function sdkApi(module) {
  return {
    /**
     * @description 소켓 수신
     */
    getSocket: function getSocket() {
      return module.ws;
    },
    /**
     * @description SDK 버전 정보 수신
     */
    getVersion: function getVersion() {
      return module.version;
    },
    /**
     * @description 구동 환경변수 수신
     */
    getEnv: function getEnv() {
      return module.env;
    },
    /**
     * @description SDK 정보 수신
     */
    getInfo: function getInfo() {
      return module.info;
    },
    /**
     * @description SDK 시작
     */
    initialize: function initialize(_ref) {
      var remining = _extends({}, _ref);
      var payload = remining;
      payload.access_token = remining.accessToken || remining.access_token;
      payload.access_token_type = remining.accessTokenType || remining.access_token_type;
      return module.initialize(payload);
    },
    /**
     * @description SDK 종료
     */
    finalize: function finalize() {
      return module.finalize();
    },
    /**
     * @description G(U)ID 등록
     */
    addGID: function addGID(_ref2) {
      var remining = _extends({}, _ref2);
      var payload = remining;
      payload.web_token = remining.webToken || remining.web_token;
      return module.addGID(payload);
    },
    /**
     * @description base64 data 전송
     */
    protobuf: function protobuf() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key4 = 0; _key4 < _len3; _key4++) {
        args[_key4] = arguments[_key4];
      }
      return void 0;
    },
    //module.protobuf(...args),

    /**
     * @description 인증
     */
    attachAuth: function attachAuth(_ref3) {
      var remining = _extends({}, _ref3);
      var payload = remining;
      payload.access_token = remining.accessToken || remining.access_token;
      payload.access_token_type = remining.accessTokenType || remining.access_token_type;
      return module.attachAuth(payload);
    },
    /**
     * @description 이벤트 구독
     */
    subscribe: function subscribe(_ref4) {
      var remining = _extends({}, _ref4);
      var payload = remining;
      payload.path_suffix = remining.pathSuffix || remining.path_suffix;
      return module.subscribe(payload);
    },
    /**
     * @description 이벤트 구독 해제
     */
    unsubscribe: function unsubscribe(_ref5) {
      var remining = _extends({}, _ref5);
      var payload = remining;
      payload.path_suffix = remining.pathSuffix || remining.path_suffix;
      return module.unsubscribe(payload);
    },
    /**
     * @description 데이터 스트림 전송
     */
    sendStream: function sendStream() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
        args[_key5] = arguments[_key5];
      }
      return void 0;
    },
    //module.sendStream(...args),

    /**
     * @description 이벤트 리스너 등록
     */
    addEventListener: function addEventListener() {
      return module.addEventListener.apply(module, arguments);
    },
    /**
     * @description 이벤트 리스너 삭제
     */
    removeEventListener: function removeEventListener() {
      return module.removeEventListener.apply(module, arguments);
    },
    /**
     * @description SDK 시작 확인
     */
    isStart: function isStart() {
      return module.isStart();
    },
    /**
     * @description SDK 시작 확인
     */
    isStandby: function isStandby() {
      return module.isStandby();
    },
    /**
     * @description SDK 종료 확인
     */
    isStop: function isStop() {
      return module.isStop();
    }
  };
};
var RawApi = rawApi;
var SDKApi = sdkApi;

/** 이벤트 매니저
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module EventManager
 */
var EventManager$1 = /*#__PURE__*/function () {
  function EventManager$1() {
    _classCallCheck(this, EventManager$1);
    this._event = {};
  }
  /**
   * 이벤트 매니저: 리스너 추가
   *
   * @memberof EventManager
   * @param {string} eventType 이벤트 이름
   * @param {callback} callback 리스너 콜백
   */
  return _createClass(EventManager$1, [{
    key: "addEventListener",
    value: function addEventListener(eventType, callback) {
      try {
        if (typeof eventType !== 'string') {
          callback(false);
        }
        if (!this._event) {
          this._event = {};
        }
        if (!this._event[eventType]) {
          this._event[eventType] = [];
        }
        this._event[eventType].push(callback);
        return callback;
      } catch (error) {
        console.error(error);
      }
    }
    /**
     * 이벤트 매니저: 리스너 디스패치
     *
     * @memberof EventManager
     * @param {string} eventType 이벤트 이름
     * @param {object} args 콜백 인자
     */
  }, {
    key: "dispatch",
    value: function dispatch(eventType) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key6 = 1; _key6 < _len5; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      try {
        if (typeof eventType !== 'string') {
          return false;
        }
        var type = eventType.toLowerCase();
        if (type && this._event[type]) {
          this._event[type].forEach(function (listener) {
            listener.apply(void 0, args);
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    /**
     * 이벤트 매니저: 리스너 전체 디스패치
     *
     * @memberof EventManager
     * @param {object} args 콜백 인자
     */
  }, {
    key: "dispatchAll",
    value: function dispatchAll() {
      try {
        if (Object.keys(this._event).length !== 0) {
          for (var _len6 = arguments.length, args = new Array(_len6), _key7 = 0; _key7 < _len6; _key7++) {
            args[_key7] = arguments[_key7];
          }
          for (var eventType in this._event) {
            this.dispatch.apply(this, [eventType].concat(args));
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
    /**
     * 이벤트 매니저: 리스너 삭제
     *
     * @memberof EventManager
     * @param {string} eventType 이벤트 이름 or 리스너 콜백
     */
  }, {
    key: "removeEventListener",
    value: function removeEventListener(eventTypeOrCallBack) {
      var _this7 = this;
      try {
        if (!this._event) this._event = {};
        if (typeof eventTypeOrCallBack === 'string') {
          var eventType = eventTypeOrCallBack;
          var eventTarget = this._event[eventType];
          if (eventTarget) this._event[eventType] = [];
        } else if (typeof eventTypeOrCallBack === 'function') {
          var targetEvent = eventTypeOrCallBack;
          var eventKeyList = Object.keys(this._event);
          eventKeyList.forEach(function (_key) {
            _this7._event[_key] = _this7._event[_key].filter(function (listener) {
              return listener !== targetEvent;
            });
          });
        }
      } catch (error) {
        console.error(error);
      }
    }
    /**
     * 이벤트 매니저: 리스너 전체 삭제
     *
     * @memberof EventManager
     */
  }, {
    key: "removeEventListenerAll",
    value: function removeEventListenerAll() {
      this._event = {};
    }
  }]);
}();
/** 서비스 URL param option 관리
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module ServiceParam
 */
var ServiceParam$1 = /*#__PURE__*/function () {
  function ServiceParam$1() {
    _classCallCheck(this, ServiceParam$1);
    this._type = 'service_params';
    this._map = {};
  }
  /**
   * GET URL param key
   *
   * @memberof ServiceParam
   * @param {string} key URL param key
   * @returns {Map}
   */
  return _createClass(ServiceParam$1, [{
    key: "get",
    value: function get(key) {
      if (!this._map) {
        this._map = {};
      }
      return this._map[key];
    }
    /**
     * SET URL param key
     *
     * @memberof ServiceParam
     * @param {string} key URL param key
     * @param {string} value URL param value
     */
  }, {
    key: "set",
    value: function set(key, value) {
      if (!this._map) {
        this._map = {};
      }
      this._map[key] = value;
    }
    /**
     * REMOVE URL param key
     *
     * @memberof ServiceParam
     * @param {string} key URL param key
     */
  }, {
    key: "remove",
    value: function remove(key) {
      if (!this._map) {
        this._map = {};
      }
      this._map[key] = undefined;
    }
    /**
     * GET URL params
     *
     * @memberof ServiceParam
     * @returns {Mastringp}
     */
  }, {
    key: "toURLQuery",
    value: function toURLQuery() {
      return Object.entries(this._map).reduce(function (arr, _ref16) {
        var _ref17 = _slicedToArray(_ref16, 2),
          key = _ref17[0],
          value = _ref17[1];
        if (!value && value !== 0 && value !== false && value !== '') {
          return arr;
        }
        arr.push("".concat(key, "=").concat(value));
        return arr;
      }, []).join('&') || '';
    }
  }]);
}();
var EventManager = EventManager$1;
var ServiceParam = ServiceParam$1;

/** inface-sdk/common 모듈 통한 현 디바이스 값 GET
 * @author 임채성
 * @function util/currentDevice
 * @return {string}
 */

var currentDevice = function currentDevice() {
  try {
    return InfaceEnv.device().type === InfaceEnv.DEVICE_TYPES.BROWSER ? 'web' : InfaceEnv.device().type.toLowerCase();
  } catch (error) {
    DEBUG.error(error);
    return WS_ENUM.SDK_TYPE_DESKTOP;
  }
};
/** inface-sdk/common 모듈 통한 현 플랫폼 값 GET
 * @author 박희용
 * @function util/currentPlatform
 * @return {string}
 */

var currentPlatform = function currentPlatform() {
  var platformValue = '';
  if (InfaceEnv && InfaceEnv.device().type === InfaceEnv.DEVICE_TYPES.BROWSER && typeof navigator !== 'undefined') {
    var platform = navigator.userAgentData ? navigator.userAgentData.platform.toLowerCase() : navigator.userAgent.toLowerCase();
    if (/win/.test(platform)) platformValue = 'windows';else if ([/darwin/, /mac/].some(function (reg) {
      return reg.test(platform);
    })) platformValue = 'mac';else platformValue = platform;
  } else {
    platformValue = InfaceEnv.getCurrentPlatform();
  }
  return platformValue;
};
/** 서버 프로토콜 수신 응답 프로퍼티 키 맵핑
 * @author 박희용
 * @function util/mappingProtocolKey
 * @param {Object} payload 서버 프로토콜 수신 페이로드
 * @return {Object}
 */

var mappingProtocolKey = function mappingProtocolKey() {
  var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  try {
    var _WS_ENUM$KEY = WS_ENUM.KEY,
      TYPE = _WS_ENUM$KEY.TYPE,
      BODY = _WS_ENUM$KEY.BODY,
      ERROR = _WS_ENUM$KEY.ERROR,
      META = _WS_ENUM$KEY.META,
      CLIENT_REQUEST_TIME = _WS_ENUM$KEY.CLIENT_REQUEST_TIME,
      SERVER_REQUEST_TIME = _WS_ENUM$KEY.SERVER_REQUEST_TIME,
      SERVER_RESPONSE_TIME = _WS_ENUM$KEY.SERVER_RESPONSE_TIME,
      ERROR_NAME = _WS_ENUM$KEY.ERROR_NAME,
      ERROR_MESSAGE = _WS_ENUM$KEY.ERROR_MESSAGE,
      ERROR_STACK = _WS_ENUM$KEY.ERROR_STACK,
      ERROR_DATA = _WS_ENUM$KEY.ERROR_DATA;
    var map = {
      type: payload[TYPE] || payload.type,
      body: payload[BODY] || payload.body,
      meta: {},
      error: payload[ERROR] || payload.error ? {} : undefined
    };
    if (payload[META] || payload.meta) {
      map.meta[CLIENT_REQUEST_TIME] = payload[META] ? payload[META][CLIENT_REQUEST_TIME] : payload.meta.client_request_time;
      map.meta[SERVER_REQUEST_TIME] = payload[META] ? payload[META][SERVER_REQUEST_TIME] : payload.meta.server_request_time;
      map.meta[SERVER_RESPONSE_TIME] = payload[META] ? payload[META][SERVER_RESPONSE_TIME] : payload.meta.server_response_time;
    }
    if (map.error) {
      map.error[ERROR_NAME] = payload[ERROR] ? payload[ERROR][ERROR_NAME] : payload.error.name;
      map.error[ERROR_MESSAGE] = payload[ERROR] ? payload[ERROR][ERROR_MESSAGE] : payload.error.message;
      map.error[ERROR_STACK] = payload[ERROR] ? payload[ERROR][ERROR_STACK] : payload.error.stack;
      map.error[ERROR_DATA] = payload[ERROR] ? payload[ERROR][ERROR_DATA] : payload.error.data;
    }
    return map;
  } catch (error) {
    DEBUG.error(error);
    return _extends({}, payload);
  }
};
/** 서버 응답 본문 컴파일
 * @author 박희용
 * @function util/compileResponse
 * @param {Object} res 서버 응답 페이로드
 * @return {boolean}
 */

var compileResponse = function compileResponse(_ref18) {
  var res = _ref18.res;
  try {
    var _mappingProtocolKey = mappingProtocolKey(res),
      type = _mappingProtocolKey.type,
      body = _mappingProtocolKey.body,
      meta = _mappingProtocolKey.meta,
      error = _mappingProtocolKey.error;
    if (!error) throwLSError({
      payload: {
        type: type,
        body: body,
        meta: meta
      },
      name: 'SERVER_RESPONSE_UNDEFINED_DATA_ERROR',
      type: type
    });
    var splitTypeList = type.split(WS_ENUM.ACTION_SEPARATOR);
    var name = splitTypeList[0] || LS_ENUM.MODULE_NAME_ABB;
    var action = splitTypeList[1] || '';
    return {
      name: name,
      action: action,
      type: type,
      body: body,
      meta: meta,
      error: error
    };
  } catch (error) {
    throw error;
  }
};
/** path한정 구독 리스트 추가
 * @author 박희용
 * @function util/addSubscribeListOnlyPath
 * @param {Object} stream 스트림 이름
 * @param {Object} path 구독할 게임
 * @param {Object} subscribeList 모듈에 저장된 구독 리스트
 * @return {boolean}
 */

var addSubscribeListOnlyPath = function addSubscribeListOnlyPath(_ref19) {
  var stream = _ref19.stream,
    path = _ref19.path,
    subscribeList = _ref19.subscribeList;
  try {
    var fileteredList = subscribeList.filter(function (item) {
      return item && item.path && item.path === path && (!item.path_suffix || !item.path_suffix.size);
    });
    if (!fileteredList || !fileteredList.length) {
      var subscribeObj = {
        path: path,
        stream: stream
      };
      return [].concat(_toConsumableArray(subscribeList), [subscribeObj]);
    } else return subscribeList;
  } catch (error) {
    throw error;
  }
};
/** 구독 리스트 추가
 * @author 박희용
 * @function util/addSubscribeList
 * @param {Object} stream 스트림 이름
 * @param {Object} path 구독할 게임
 * @param {Object} subscribeList 모듈에 저장된 구독 리스트
 * @return {boolean}
 * @description
 * 구독 리스트 추가
 * filteredList: 동일한 path 및 path_suffix 보유
 * preservedList: 다른 path + 동일한 path 및 path_suffix 미보유
 */

var addSubscribeList = function addSubscribeList(_ref20) {
  var stream = _ref20.stream,
    path = _ref20.path,
    path_suffix = _ref20.path_suffix,
    subscribeList = _ref20.subscribeList;
  try {
    var subscribeObj = {
      path: path,
      stream: stream
    };
    var fileteredList = subscribeList.filter(function (item) {
      return item && item.path && item.path === path && item.path_suffix && item.path_suffix.size;
    });
    var preservedList = subscribeList.filter(function (item) {
      return item && item.path && (item.path !== path || item.path === path && (!item.path_suffix || !item.path_suffix.size));
    });
    if (!fileteredList || !fileteredList.length) subscribeObj.path_suffix = new Set(_toConsumableArray(path_suffix));else {
      subscribeObj.path_suffix = fileteredList[0].path_suffix;
      var _iterator = _createForOfIteratorHelper(path_suffix),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var elem = _step.value;
          subscribeObj.path_suffix.add(elem);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    return [].concat(_toConsumableArray(preservedList), [subscribeObj]);
  } catch (error) {
    throw error;
  }
};
/** path한정 구독 리스트 삭제
 * @author 박희용
 * @function util/removeSubscribeListOnlyPath
 * @param {Object} path 구독해제할 게임
 * @param {Object} subscribeList 모듈에 저장된 구독 리스트
 * @return {boolean}
 */

var removeSubscribeListOnlyPath = function removeSubscribeListOnlyPath(_ref21) {
  var path = _ref21.path,
    subscribeList = _ref21.subscribeList;
  try {
    return subscribeList.filter(function (item) {
      return item && item.path && (item.path !== path || item.path_suffix && item.path_suffix.size);
    });
  } catch (error) {
    throw error;
  }
};
/** 구독 리스트 삭제
 * @author 박희용
 * @function util/removeSubscribeList
 * @param {Object} stream 스트림 이름
 * @param {Object} path 구독해제할 게임
 * @param {Object} subscribeList 모듈에 저장된 구독 리스트
 * @return {boolean}
 */

var removeSubscribeList = function removeSubscribeList(_ref22) {
  var stream = _ref22.stream,
    path = _ref22.path,
    path_suffix = _ref22.path_suffix,
    subscribeList = _ref22.subscribeList;
  try {
    var subscribeObj = {};
    var fileteredList = subscribeList.filter(function (item) {
      return item && item.path && item.path === path && item.path_suffix && item.path_suffix.size;
    });
    var preservedList = subscribeList.filter(function (item) {
      return item && item.path && (item.path !== path || !item.path_suffix || !item.path_suffix.size);
    });
    if (fileteredList && fileteredList.length) {
      subscribeObj.stream = stream;
      subscribeObj.path = path;
      subscribeObj.path_suffix = fileteredList[0].path_suffix;
      var _iterator2 = _createForOfIteratorHelper(path_suffix),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var elem = _step2.value;
          subscribeObj.path_suffix.delete(elem);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
    if (!subscribeObj.path_suffix || !subscribeObj.path_suffix.size) return _toConsumableArray(preservedList);
    return [].concat(_toConsumableArray(preservedList), [subscribeObj]);
  } catch (error) {
    throw error;
  }
};
/**
 * 제공되는 cid 목록에서 사용할 수 있는 상태의 cid 값을 가져와 리턴합니다
 * @author 임채성
 * @function util/getCIDFromPool
 * @param {object} namespacePath game token path 값
 * @return {string}
 */
function getCIDFromPool(_x) {
  return _getCIDFromPool.apply(this, arguments);
}
/**
 * 비활성화된 소켓에서 사용한 cid 를 local 파일에 비활성화 상태로 저장합니다.
 * @author 박희용
 * @function util/setCIDIntoPool
 * @param {cid} cid 값
 * @return {string}
 */
function _getCIDFromPool() {
  _getCIDFromPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee24(_ref23) {
    var namespacePath, loadFromStorage, cidPool, addSize, cids, resultIndex, _iterator6, _step6, index;
    return _regeneratorRuntime().wrap(function _callee24$(_context24) {
      while (1) switch (_context24.prev = _context24.next) {
        case 0:
          namespacePath = _ref23.namespacePath;
          if (namespacePath) {
            _context24.next = 3;
            break;
          }
          return _context24.abrupt("return", false);
        case 3:
          _context24.t0 = InfaceEnv;
          if (!_context24.t0) {
            _context24.next = 8;
            break;
          }
          _context24.next = 7;
          return InfaceEnv.load();
        case 7:
          _context24.t0 = _context24.sent;
        case 8:
          loadFromStorage = _context24.t0;
          if (!(!loadFromStorage || !loadFromStorage.status)) {
            _context24.next = 11;
            break;
          }
          return _context24.abrupt("return", '');
        case 11:
          cidPool = InfaceEnv.namespace(namespacePath).get('cid_pool');
          if (!cidPool || cidPool.length !== 11) cidPool = [];
          addSize = 11 - (cidPool ? cidPool.length : 0);
          cids = [].concat(_toConsumableArray(cidPool), _toConsumableArray(Array(addSize))).map(function (item, _index) {
            return {
              value: item && item.value || generateUUID(),
              use: item && item.use || false,
              accessAt: item && item.accessAt || 0
            };
          });
          InfaceEnv.namespace(namespacePath).set('cid_pool', cids);
          _context24.next = 18;
          return InfaceEnv.namespace(namespacePath).save();
        case 18:
          cidPool = InfaceEnv.namespace(namespacePath).get('cid_pool');
          cidPool.sort(function (a, b) {
            return a.value > b.value ? 1 : b.value > a.value ? -1 : 0;
          });
          _iterator6 = _createForOfIteratorHelper(cidPool.keys());
          _context24.prev = 21;
          _iterator6.s();
        case 23:
          if ((_step6 = _iterator6.n()).done) {
            _context24.next = 34;
            break;
          }
          index = _step6.value;
          if (cidPool[index].use) {
            _context24.next = 28;
            break;
          }
          resultIndex = index;
          return _context24.abrupt("break", 34);
        case 28:
          if (!(index === cidPool.length - 1)) {
            _context24.next = 32;
            break;
          }
          cidPool.sort(function (a, b) {
            return a.accessAt > b.accessAt ? 1 : b.accessAt > a.accessAt ? -1 : 0;
          });
          resultIndex = 0;
          return _context24.abrupt("break", 34);
        case 32:
          _context24.next = 23;
          break;
        case 34:
          _context24.next = 39;
          break;
        case 36:
          _context24.prev = 36;
          _context24.t1 = _context24["catch"](21);
          _iterator6.e(_context24.t1);
        case 39:
          _context24.prev = 39;
          _iterator6.f();
          return _context24.finish(39);
        case 42:
          cidPool[resultIndex].use = true;
          cidPool[resultIndex].accessAt = new Date().getTime();
          InfaceEnv.namespace(namespacePath).set('cid_pool', cidPool);
          _context24.next = 47;
          return InfaceEnv.namespace(namespacePath).save();
        case 47:
          return _context24.abrupt("return", cidPool[resultIndex].value);
        case 48:
        case "end":
          return _context24.stop();
      }
    }, _callee24, null, [[21, 36, 39, 42]]);
  }));
  return _getCIDFromPool.apply(this, arguments);
}
function setCIDIntoPool(_x2) {
  return _setCIDIntoPool.apply(this, arguments);
}
/** URL 파라미터 옵션 생성
 * @author 박희용
 * @function util/generateUrlOption
 * @param {string} path
 * @param {string} cid
 * @return {ServiceParam}
 */
function _setCIDIntoPool() {
  _setCIDIntoPool = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee25(_ref24) {
    var namespacePath, cid, loadFromStorage, cidPool, _iterator7, _step7, index;
    return _regeneratorRuntime().wrap(function _callee25$(_context25) {
      while (1) switch (_context25.prev = _context25.next) {
        case 0:
          namespacePath = _ref24.namespacePath, cid = _ref24.cid;
          if (!(!namespacePath || !cid)) {
            _context25.next = 3;
            break;
          }
          return _context25.abrupt("return", false);
        case 3:
          _context25.t0 = InfaceEnv;
          if (!_context25.t0) {
            _context25.next = 8;
            break;
          }
          _context25.next = 7;
          return InfaceEnv.load();
        case 7:
          _context25.t0 = _context25.sent;
        case 8:
          loadFromStorage = _context25.t0;
          if (!(!loadFromStorage || !loadFromStorage.status)) {
            _context25.next = 11;
            break;
          }
          return _context25.abrupt("return", false);
        case 11:
          cidPool = InfaceEnv.namespace(namespacePath).get('cid_pool');
          if (cidPool) {
            _context25.next = 14;
            break;
          }
          return _context25.abrupt("return", false);
        case 14:
          _iterator7 = _createForOfIteratorHelper(cidPool.keys());
          _context25.prev = 15;
          _iterator7.s();
        case 17:
          if ((_step7 = _iterator7.n()).done) {
            _context25.next = 27;
            break;
          }
          index = _step7.value;
          if (!(cidPool[index].value === cid)) {
            _context25.next = 25;
            break;
          }
          cidPool[index].use = false;
          InfaceEnv.namespace(namespacePath).set('cid_pool', cidPool);
          _context25.next = 24;
          return InfaceEnv.namespace(namespacePath).save();
        case 24:
          return _context25.abrupt("break", 27);
        case 25:
          _context25.next = 17;
          break;
        case 27:
          _context25.next = 32;
          break;
        case 29:
          _context25.prev = 29;
          _context25.t1 = _context25["catch"](15);
          _iterator7.e(_context25.t1);
        case 32:
          _context25.prev = 32;
          _iterator7.f();
          return _context25.finish(32);
        case 35:
          return _context25.abrupt("return", true);
        case 36:
        case "end":
          return _context25.stop();
      }
    }, _callee25, null, [[15, 29, 32, 35]]);
  }));
  return _setCIDIntoPool.apply(this, arguments);
}
var generateUrlOption = /*#__PURE__*/function () {
  var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref25) {
    var path, cid, PROTOCOL_VERSION_LATEST, PROTOCOL_VERSION_DEFAULT, SDK_TYPE_DESKTOP, PROTOCOL_VERSION, SDK_VERSION, SDK_PLATFORM, SDK_TYPE, CID, HWID, option, sdkVersionValue, sdkPlatformValue, hwIdValue, sdkTypeValue, protocolVersionValue, cidValue;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          path = _ref25.path, cid = _ref25.cid;
          _context3.prev = 1;
          PROTOCOL_VERSION_LATEST = WS_ENUM.PROTOCOL_VERSION_LATEST, PROTOCOL_VERSION_DEFAULT = WS_ENUM.PROTOCOL_VERSION_DEFAULT, SDK_TYPE_DESKTOP = WS_ENUM.SDK_TYPE_DESKTOP, PROTOCOL_VERSION = WS_ENUM.PROTOCOL_VERSION, SDK_VERSION = WS_ENUM.SDK_VERSION, SDK_PLATFORM = WS_ENUM.SDK_PLATFORM, SDK_TYPE = WS_ENUM.SDK_TYPE, CID = WS_ENUM.CID, HWID = WS_ENUM.HWID;
          option = new ServiceParam();
          sdkVersionValue = InfaceEnv.value.INFACE_VERSION || '';
          sdkPlatformValue = currentPlatform() || '';
          hwIdValue = getModuleApi('nugu_sdk') && getModuleApi('nugu_sdk').get_hwid_md5 ? getModuleApi('nugu_sdk').get_hwid_md5() : '';
          sdkTypeValue = currentDevice() || SDK_TYPE_DESKTOP;
          protocolVersionValue = !sdkVersionValue ? PROTOCOL_VERSION_DEFAULT : PROTOCOL_VERSION_LATEST;
          _context3.t0 = cid;
          if (_context3.t0) {
            _context3.next = 14;
            break;
          }
          _context3.next = 13;
          return getCIDFromPool({
            namespacePath: path
          });
        case 13:
          _context3.t0 = _context3.sent;
        case 14:
          cidValue = _context3.t0;
          option.set(PROTOCOL_VERSION, protocolVersionValue);
          option.set(SDK_VERSION, sdkVersionValue);
          option.set(SDK_PLATFORM, sdkPlatformValue);
          option.set(SDK_TYPE, sdkTypeValue);
          option.set(CID, cidValue);
          option.set(HWID, hwIdValue);
          return _context3.abrupt("return", option);
        case 24:
          _context3.prev = 24;
          _context3.t1 = _context3["catch"](1);
          DEBUG.error(_context3.t1);
          return _context3.abrupt("return", new ServiceParam());
        case 28:
        case "end":
          return _context3.stop();
      }
    }, _callee3, null, [[1, 24]]);
  }));
  return function generateUrlOption(_x3) {
    return _ref26.apply(this, arguments);
  };
}();
/** token에서 UID 추출
 * @author 박희용
 * @function util/extractUIDFromToken
 * @param {string} token
 * @return {uid}
 */

var extractUIDFromToken = function extractUIDFromToken(_ref27) {
  var token = _ref27.token;
  try {
    var splitToken = token.split('@');
    if (splitToken.length < 2) return null;
    var uidWithToken = splitToken[0].split(':');
    return uidWithToken.length > 1 ? uidWithToken[uidWithToken.length - 1] : null;
  } catch (error) {
    DEBUG.error(error);
    return null;
  }
};
/** Pool에서 Utoken GET
 * @author 박희용
 * @function util/getUtokenFromPool
 * @param {string} token
 * @return {utoken}
 */

var getUtokenFromPool = /*#__PURE__*/function () {
  var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(_ref28) {
    var uid, loadFromStrage, utoken;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1) switch (_context4.prev = _context4.next) {
        case 0:
          uid = _ref28.uid;
          _context4.prev = 1;
          _context4.t0 = InfaceEnv;
          if (!_context4.t0) {
            _context4.next = 7;
            break;
          }
          _context4.next = 6;
          return InfaceEnv.load();
        case 6:
          _context4.t0 = _context4.sent;
        case 7:
          loadFromStrage = _context4.t0;
          if (!(!uid || !loadFromStrage || !loadFromStrage.status)) {
            _context4.next = 10;
            break;
          }
          return _context4.abrupt("return", '');
        case 10:
          utoken = InfaceEnv.namespace(uid).get('utoken');
          if (utoken) {
            _context4.next = 13;
            break;
          }
          return _context4.abrupt("return", null);
        case 13:
          return _context4.abrupt("return", utoken);
        case 16:
          _context4.prev = 16;
          _context4.t1 = _context4["catch"](1);
          DEBUG.error(_context4.t1);
          return _context4.abrupt("return", null);
        case 20:
        case "end":
          return _context4.stop();
      }
    }, _callee4, null, [[1, 16]]);
  }));
  return function getUtokenFromPool(_x4) {
    return _ref29.apply(this, arguments);
  };
}();
/** Pool에 Utoken SET
 * @author 박희용
 * @function util/setUtokenInPool
 * @param {string} uid
 * @param {string} utoken
 */

var setUtokenInPool = /*#__PURE__*/function () {
  var _ref31 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref30) {
    var uid, utoken, loadFromStrage;
    return _regeneratorRuntime().wrap(function _callee5$(_context5) {
      while (1) switch (_context5.prev = _context5.next) {
        case 0:
          uid = _ref30.uid, utoken = _ref30.utoken;
          _context5.prev = 1;
          _context5.t0 = InfaceEnv;
          if (!_context5.t0) {
            _context5.next = 7;
            break;
          }
          _context5.next = 6;
          return InfaceEnv.load();
        case 6:
          _context5.t0 = _context5.sent;
        case 7:
          loadFromStrage = _context5.t0;
          if (!(!uid || !utoken || !loadFromStrage || !loadFromStrage.status)) {
            _context5.next = 10;
            break;
          }
          return _context5.abrupt("return", false);
        case 10:
          InfaceEnv.namespace(uid).set('utoken', utoken);
          _context5.next = 13;
          return InfaceEnv.namespace(uid).save();
        case 13:
          return _context5.abrupt("return", true);
        case 16:
          _context5.prev = 16;
          _context5.t1 = _context5["catch"](1);
          DEBUG.error(_context5.t1);
        case 19:
        case "end":
          return _context5.stop();
      }
    }, _callee5, null, [[1, 16]]);
  }));
  return function setUtokenInPool(_x5) {
    return _ref31.apply(this, arguments);
  };
}();
var _validateNegotiation = function _validateNegotiation(message) {
  if (!message || !message.body || !message.body.negotiation) {
    return {
      pingTimeout: LS_ENUM.PING_TIMEOUT,
      pingIntalval: LS_ENUM.PING_INTERVAL_TIME,
      protocolTimeout: LS_ENUM.REQUEST_TIMEOUT_SECOND_MAX,
      retry: LS_ENUM.REQUEST_COUNT_MAX
    };
  }
  var nego = message.body.negotiation;
  var pingTimeout = nego.ping_timeout && nego.ping_timeout > 0 ? nego.ping_timeout * 1000 : LS_ENUM.PING_TIMEOUT;
  var pingIntalval = nego.ping_interval && nego.ping_interval > 0 ? nego.ping_interval * 1000 : LS_ENUM.PING_INTERVAL_TIME;
  var protocolTimeout = nego.protocol_timeout && nego.protocol_timeout > 0 ? nego.protocol_timeout * 1000 : LS_ENUM.REQUEST_TIMEOUT_SECOND_MAX;
  var retry = nego.retry && nego.retry > 0 ? nego.retry : LS_ENUM.REQUEST_COUNT_MAX;
  return {
    pingTimeout: pingTimeout,
    pingIntalval: pingIntalval,
    protocolTimeout: protocolTimeout,
    retry: retry
  };
};
/**
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module hook
 * @param {Object} socket 소켓 모듈 참조
 * @param {Object} message 소켓 응답 메세지
 * @description
 * 라이브스트림 메세지 훅
 * 오직 LS 내부에서만 사용될 이벤트를 hooking 합니다.
 * 이곳에서 hooking된 이벤트는 타 모듈에서 listen 할 수 없습니다.
 */

var LivestreamMessageHook$1 = function LivestreamMessageHook$1(_ref32) {
  var socket = _ref32.socket;
  try {
    var _WS_ENUM$EVENT = WS_ENUM.EVENT,
      CONNECT = _WS_ENUM$EVENT.CONNECT,
      CREATE_UTOKEN = _WS_ENUM$EVENT.CREATE_UTOKEN,
      AUTH = _WS_ENUM$EVENT.AUTH,
      MAINTENANCE = _WS_ENUM$EVENT.MAINTENANCE,
      NEGOTIATION = _WS_ENUM$EVENT.NEGOTIATION,
      ADD_GID_BY_WEB_TOKEN = _WS_ENUM$EVENT.ADD_GID_BY_WEB_TOKEN;
    return _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, CONNECT, function (message) {
      socket.negotiation = _validateNegotiation(message);
      var cid = socket.cid = message.body && message.body.cid;
      var lsAlias = socket.lsAlias = message.body && message.body.ls_alias;
      cid && InfaceEnv.namespace(socket._path).set('cid', cid); // cid 로컬 저장

      lsAlias && InfaceEnv.namespace(socket._path).set('lsAlias', lsAlias); // cid 로컬 저장

      InfaceEnv.save();
      socket.livestreamEvent.dispatch(message.type, _extends({}, message));
    }), NEGOTIATION, function (message) {
      socket.negotiation = _validateNegotiation(message);
      socket.livestreamEvent.dispatch(message.type, _extends({}, message));
    }), CREATE_UTOKEN, function (message) {
      socket.utoken = message.body && message.body.utoken;
      socket.livestreamEvent.dispatch(message.type, _extends({}, message));
    }), ADD_GID_BY_WEB_TOKEN, function (message) {
      socket.gid = message.body && message.body.gid;
      socket.webToken = message.body && message.body.web_token;
      socket.livestreamEvent.dispatch(message.type, _extends({}, message));
    }), AUTH, function (message) {
      socket.livestreamEvent.dispatch(message.type, _extends({}, message));
    }), MAINTENANCE, function (message) {
      socket.livestreamEvent.dispatch(message.type, _extends({}, message));
    });
  } catch (error) {
    DEBUG.error(error);
  }
};

/** 일반 메세지 훅
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @module hook
 * @param {Object} socket 소켓 모듈 참조
 * @param {Object} message 소켓 응답 메세지
 */

var GeneralMessageHook$1 = function GeneralMessageHook$1(_ref34) {
  var socket = _ref34.socket,
    message = _ref34.message;
  try {
    if (!message || !message.type || !message.name || !message.action) return;
    socket.event.dispatch(message.name, message);
    socket.event.dispatch('*', message);
  } catch (error) {
    DEBUG.error(error);
  }
};
var LivestreamMessageHook = LivestreamMessageHook$1;
var GeneralMessageHook = GeneralMessageHook$1;

/** 소켓 healthcheck 프로토콜
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @class
 * @classdesc 소켓 통신 ping/pong 작업
 */
var HealthcheckProtocol$1 = /*#__PURE__*/function () {
  function HealthcheckProtocol$1(_ref35) {
    var _this8 = this;
    var socket = _ref35.socket;
    _classCallCheck(this, HealthcheckProtocol$1);
    this._handlers = [];
    this._isFirstPing = true;
    this._isActiveRule = false;
    this._event = new EventManager$1();
    this._socket = socket;
    this._socket.livestreamEvent.addEventListener(WS_ENUM.EVENT.WS_PONG, function (_res) {
      if (_this8._isFirstPing) _this8._isFirstPing = false;
      _this8._resetInterval();
      _this8._setPingHandler();
    });
  }
  return _createClass(HealthcheckProtocol$1, [{
    key: "type",
    get: function get() {
      return 'healthcheck_protocol';
    }
  }, {
    key: "event",
    get: function get() {
      return this._event;
    }
  }, {
    key: "isActivate",
    get: function get() {
      return this._isActiveRule;
    }
  }, {
    key: "_setPingHandler",
    value: function _setPingHandler() {
      var _this9 = this;
      try {
        var pingHandler = setTimeout(function () {
          _this9._socket.ping();
          _this9._setPingTimeout();
        }, this._socket.negotiation.pingIntalval);
        this._handlers.push(pingHandler);
      } catch (error) {
        DEBUG.error(error);
      }
    }
  }, {
    key: "_setPingTimeout",
    value: function _setPingTimeout() {
      var _this10 = this;
      try {
        var timeoutDisconnect = setTimeout(function () {
          _this10._event.dispatch(WS_ENUM.EVENT.WS_PING_TIMEOUT);
          _this10._resetInterval();
        }, this._socket.negotiation.pingTimeout);
        this._handlers.push(timeoutDisconnect);
      } catch (error) {
        DEBUG.error(error);
      }
    }
  }, {
    key: "_resetInterval",
    value: function _resetInterval() {
      this._handlers.forEach(function (handler) {
        return clearTimeout(handler);
      });
      this._handlers = [];
    }
    /**
     * LS 서버 Health Check 프로토콜 시작
     * @memberof HealthcheckProtocol
     */
  }, {
    key: "start",
    value: function start() {
      try {
        this._isActiveRule = true;
        if (this._socket && this._socket.ping && this._isFirstPing) {
          this._setPingTimeout();
          this._socket.ping();
        }
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * LS 서버 Health Check 프로토콜 종료
     * @memberof HealthcheckProtocol
     */
  }, {
    key: "end",
    value: function end() {
      if (!this._isActiveRule) return;
      try {
        this._isActiveRule = false;
        this._isFirstPing = true;
        this._resetInterval();
      } catch (error) {
        DEBUG.error(error);
      }
    }
  }]);
}();
/** 연결 유지 프로토콜
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @class
 * @classdesc 소켓 통신 연결 유지를 위한 작업
 * WS_RECONNECT로 dispatch 하여 reconnect 합니다.
 */
var KeepAliveProtocol$1 = /*#__PURE__*/function () {
  function KeepAliveProtocol$1(_ref36) {
    var _this11 = this;
    var socket = _ref36.socket,
      _ref36$intervalTime = _ref36.intervalTime,
      intervalTime = _ref36$intervalTime === void 0 ? LS_ENUM.BINARY_BACK_OFF_INTERVAL_TIME : _ref36$intervalTime;
    _classCallCheck(this, KeepAliveProtocol$1);
    this.reconnectHandler = null;
    this.reconnectTimeout = null;
    this._isActiveRule = false;
    this._reconnectCount = 0;
    this._intervalTime = intervalTime;
    this._socket = socket;
    this._event = new EventManager$1();
    this._event.addEventListener(WS_ENUM.EVENT.WS_RECONNECT, function (_res) {
      _this11._reconnect();
    });
  }
  return _createClass(KeepAliveProtocol$1, [{
    key: "type",
    get: function get() {
      return 'keep_alive_protocol';
    }
  }, {
    key: "event",
    get: function get() {
      return this._event;
    }
  }, {
    key: "_resetValue",
    value: function _resetValue() {
      this._reconnectCount = 0;
    }
  }, {
    key: "_increaseReconnectCount",
    value: function _increaseReconnectCount() {
      this._reconnectCount = this._reconnectCount + 1;
    }
  }, {
    key: "_getIntervalTime",
    value: function _getIntervalTime() {
      return this._intervalTime * Math.pow(2, this._reconnectCount); // 이진 지수 백오프
    }
  }, {
    key: "_resetHandler",
    value: function _resetHandler() {
      if (!this.reconnectHandler) return;
      this._socket.livestreamEvent.removeEventListener(this.reconnectHandler);
      this.reconnectHandler = null;
    }
  }, {
    key: "_resetTimeout",
    value: function _resetTimeout() {
      if (!this.reconnectTimeout) return;
      clearTimeout(this.reconnectTimeout);
      this.reconnectTimeout = null;
    }
  }, {
    key: "_reconnect",
    value: function _reconnect() {
      var _this12 = this;
      var _this = this;
      try {
        this._resetHandler();
        this._resetTimeout();
        this.reconnectHandler = this._socket.livestreamEvent.addEventListener(WS_ENUM.EVENT.CONNECT, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
          return _regeneratorRuntime().wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this._reconnectionFollowUp();
              case 2:
                _this._resetValue();
                _this._resetHandler();
              case 4:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        })));
        this.reconnectTimeout = setTimeout(function () {
          _this12._increaseReconnectCount();
          _this12._socket._connect(_this12._socket.url);
          _this12._resetTimeout();
        }, this._getIntervalTime());
      } catch (error) {
        DEBUG.error(error);
      }
    }
  }, {
    key: "_reconnectionFollowUp",
    value: function () {
      var _reconnectionFollowUp2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var unsubscribe, unsubscribeWithSuffix, _iterator3, _step3, item, compiledItem, _payload2, gid, webToken;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              /* 요청큐에서 구독해제 제거 */

              try {
                unsubscribe = LS_ENUM.IM_GAME + WS_ENUM.ACTION_SEPARATOR + WS_ENUM.EVENT.UNSUBSCRIBE;
                unsubscribeWithSuffix = LS_ENUM.IM_GAME + WS_ENUM.ACTION_SEPARATOR + WS_ENUM.EVENT.UNSUBSCRIBE_WITH_SUFFIX;
                this._socket.filterReqQueueByType({
                  type: unsubscribe
                });
                this._socket.filterReqQueueByType({
                  type: unsubscribeWithSuffix
                });
              } catch (error) {
                DEBUG.error(error);
              }
              /* 구독 (옵션) */
              _context7.prev = 1;
              if (!(this._socket._subscribeList && this._socket._subscribeList.length)) {
                _context7.next = 22;
                break;
              }
              _iterator3 = _createForOfIteratorHelper(this._socket._subscribeList);
              _context7.prev = 4;
              _iterator3.s();
            case 6:
              if ((_step3 = _iterator3.n()).done) {
                _context7.next = 14;
                break;
              }
              item = _step3.value;
              compiledItem = item;
              if (compiledItem.path_suffix && compiledItem.path_suffix.length) compiledItem.path_suffix = _toConsumableArray(compiledItem.path_suffix);
              _context7.next = 12;
              return this._socket.subscribe(compiledItem);
            case 12:
              _context7.next = 6;
              break;
            case 14:
              _context7.next = 19;
              break;
            case 16:
              _context7.prev = 16;
              _context7.t0 = _context7["catch"](4);
              _iterator3.e(_context7.t0);
            case 19:
              _context7.prev = 19;
              _iterator3.f();
              return _context7.finish(19);
            case 22:
              _context7.next = 27;
              break;
            case 24:
              _context7.prev = 24;
              _context7.t1 = _context7["catch"](1);
              DEBUG.error(_context7.t1);
            case 27:
              _context7.prev = 27;
              if (!this._socket.utoken) {
                _context7.next = 33;
                break;
              }
              _context7.next = 31;
              return this._socket.authByUtoken({
                utoken: this._socket.utoken
              });
            case 31:
              _context7.next = 37;
              break;
            case 33:
              if (!(this._socket.cid && this._socket.authTicket && this._socket.authTicket.type && this._socket.authTicket.token)) {
                _context7.next = 37;
                break;
              }
              _payload2 = {
                accessToken: this._socket.authTicket.token,
                accessTokenType: this._socket.authTicket.type
              };
              _context7.next = 37;
              return this._socket.createUtoken(_payload2);
            case 37:
              /* WEB 환경, gid 등록 (옵션) */
              gid = this._socket.gid;
              webToken = this._socket.webToken;
              if (!(InfaceEnv.isBrowser() && gid && webToken && this._socket.utoken)) {
                _context7.next = 42;
                break;
              }
              _context7.next = 42;
              return this._socket.addGID({
                gid: gid,
                webToken: webToken
              });
            case 42:
              _context7.next = 47;
              break;
            case 44:
              _context7.prev = 44;
              _context7.t2 = _context7["catch"](27);
              DEBUG.error(_context7.t2);
            case 47:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this, [[1, 24], [4, 16, 19, 22], [27, 44]]);
      }));
      function _reconnectionFollowUp() {
        return _reconnectionFollowUp2.apply(this, arguments);
      }
      return _reconnectionFollowUp;
    }()
    /**
     * LS 서버 Keep Alive 프로토콜 시작
     * @memberof KeepAliveProtocol
     */
  }, {
    key: "start",
    value: function start() {
      try {
        this._resetValue();
        this._isActiveRule = true;
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * LS 서버 Keep Alive 프로토콜 종료
     * @memberof KeepAliveProtocol
     */
  }, {
    key: "end",
    value: function end() {
      if (!this._isActiveRule) return;
      try {
        this._isActiveRule = false;
      } catch (error) {
        DEBUG.error(error);
      }
    }
  }]);
}();
var HealthcheckProtocol = HealthcheckProtocol$1;
var KeepAliveProtocol = KeepAliveProtocol$1;

/** 소켓 모듈 추상화 클래스
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @abstract
 */
var AbstractServiceSocket = /*#__PURE__*/function () {
  function AbstractServiceSocket() {
    _classCallCheck(this, AbstractServiceSocket);
    this._id = new Date().getTime();
    this._isConnected = false;
    this._connection = {};
    this._event = new EventManager();
    this._livestreamEvent = new EventManager();
    this._reqQueue = [];
  }
  return _createClass(AbstractServiceSocket, [{
    key: "id",
    get: function get() {
      return this._id;
    }
  }, {
    key: "isConnected",
    get: function get() {
      return this._isConnected;
    }
  }, {
    key: "event",
    get: function get() {
      return this._event;
    }
  }, {
    key: "livestreamEvent",
    get: function get() {
      return this._livestreamEvent;
    }
  }, {
    key: "_connect",
    value: function _connect(url) {
      var _this13 = this;
      if (this._connection && this._connection.connect) {
        this._disconnect();
        this._connection = null;
      }
      try {
        this._connection = new WSClient(url).addEventListener('*', function (_ws, res) {
          return _this13._onPMessage(res);
        }).onConnect(function () {
          return _this13._onPConnect.apply(_this13, arguments);
        }).onDisconnect(function () {
          return _this13._onPDisconnect.apply(_this13, arguments);
        }).onPing(function () {
          return _this13._onPPing.apply(_this13, arguments);
        }).onPong(function () {
          return _this13._onPPong.apply(_this13, arguments);
        }).onError(function () {
          return _this13._onPError.apply(_this13, arguments);
        }).connect();
      } catch (e) {
        console.error('ERROR ', e);
      }
    }
  }, {
    key: "_disconnect",
    value: function _disconnect() {
      if (this._connection && this._connection.disconnect) this._connection.disconnect();
    }
  }, {
    key: "_drop",
    value: function _drop() {
      this.event.removeEventListenerAll();
      this.livestreamEvent.removeEventListenerAll();
      this._disconnect();
    }
  }, {
    key: "_wsPing",
    value: function _wsPing() {
      if (this._connection && this._connection.ping) {
        this._connection.ping();
      }
    }
  }, {
    key: "_isDuplicated",
    value: function _isDuplicated(message) {
      var TYPE = WS_ENUM.KEY.TYPE;
      var BODY = WS_ENUM.KEY.BODY;
      var blacklist = [WS_ENUM.EVENT.SUBSCRIBE];
      /* 중복 제거 타입 판단 */

      var isExistType = blacklist.some(function (type) {
        return message[TYPE].includes(type);
      });
      if (!isExistType) return false;
      /* 요청큐 동일 타입 존재 판단 */

      var filteredByType = this._reqQueue.filter(function (item) {
        return item[TYPE] === message[TYPE];
      });
      if (!filteredByType || !filteredByType.length) return false;
      /* 페이로드 동일 유무 판단 */

      var filterdByPayload = filteredByType.filter(function (item) {
        var itemBody = item[BODY];
        var messageBody = message[BODY];
        for (var key in itemBody) {
          if (Array.isArray(itemBody[key]) && !lodash.isEqual(itemBody[key].sort(), messageBody[key].sort())) return false;else if (_typeof(itemBody[key]) === 'object' && !lodash.isEqual(itemBody[key], messageBody[key])) return false;else if (itemBody[key] !== messageBody[key]) return false;else return true;
        }
      });
      return filterdByPayload && filterdByPayload.length;
    }
  }, {
    key: "_emit",
    value: function _emit(message) {
      if (this._isDuplicated(message)) return LS_ERR.DUPLICATED_REQUEST;
      this._reqQueue.push(message);
      this._flush();
    }
  }, {
    key: "_immediateEmit",
    value: function _immediateEmit(message) {
      if (this._connection && this._connection.ping) {
        this._connection.emit(message);
      }
    }
  }, {
    key: "_onPConnect",
    value: function _onPConnect() {
      this._isConnected = true;
      if (this.onConnect) {
        this.onConnect();
        this._flush();
      }
    }
  }, {
    key: "_onPDisconnect",
    value: function _onPDisconnect() {
      for (var _len7 = arguments.length, args = new Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
        args[_key8] = arguments[_key8];
      }
      this._isConnected = false;
      this._connection = null;
      this.onDisconnect();
    }
  }, {
    key: "_onPPing",
    value: function _onPPing() {
      if (this.onPing) {
        this.onPing();
      }
    }
  }, {
    key: "_onPPong",
    value: function _onPPong() {
      if (this.onPong) {
        this.onPong();
      }
    }
  }, {
    key: "_onPError",
    value: function _onPError(error) {
      DEBUG.error(error);
      this.onError(error);
    }
  }, {
    key: "_onPMessage",
    value: function _onPMessage(res) {
      this.onMessage(res);
    }
  }, {
    key: "_flush",
    value: function _flush() {
      var _this14 = this;
      try {
        if (!this.isConnected) return;
        var _loop = function _loop() {
          var waitingPacketList = _this14._reqQueue.splice(0, _this14._reqQueue.length);
          var timeoutHandler = setTimeout(function () {
            clearTimeout(timeoutHandler);
            var _iterator4 = _createForOfIteratorHelper(waitingPacketList),
              _step4;
            try {
              for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                var packet = _step4.value;
                if (_this14.isConnected) _this14._immediateEmit(packet);else _this14._reqQueue.push(packet);
              }
            } catch (err) {
              _iterator4.e(err);
            } finally {
              _iterator4.f();
            }
          }, 0);
        };
        while (this._reqQueue.length > 0) {
          _loop();
        }
      } catch (error) {
        DEBUG.error(error);
      }
    }
  }, {
    key: "filterReqQueueByType",
    value: function filterReqQueueByType(_ref38) {
      var type = _ref38.type;
      try {
        var TYPE = WS_ENUM.KEY.TYPE;
        var filteredQueue = this._reqQueue.filter(function (item) {
          return item[TYPE] !== type;
        });
        this._reqQueue = filteredQueue;
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /* Abstract Method */
  }, {
    key: "onAttachAuth",
    value: function onAttachAuth(_auth) {}
  }, {
    key: "onConnect",
    value: function onConnect() {}
  }, {
    key: "onDisconnect",
    value: function onDisconnect() {}
  }, {
    key: "onPong",
    value: function onPong() {}
  }, {
    key: "onPing",
    value: function onPing() {}
  }, {
    key: "onError",
    value: function onError(_error) {}
  }, {
    key: "onMessage",
    value: function onMessage(_res) {}
  }]);
}();
/** 인증 티켓
 * @abstract
 */
var AbstractAuthTicket = /*#__PURE__*/_createClass(function AbstractAuthTicket() {
  _classCallCheck(this, AbstractAuthTicket);
});
/** game token 티켓
 * @class
 */
var GameTokenTicket = /*#__PURE__*/function (_AbstractAuthTicket) {
  function GameTokenTicket(token) {
    var _this15;
    _classCallCheck(this, GameTokenTicket);
    _this15 = _callSuper(this, GameTokenTicket);
    _this15._type = 'game_token';
    _this15._token = token;
    return _this15;
  }
  _inherits(GameTokenTicket, _AbstractAuthTicket);
  return _createClass(GameTokenTicket, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * 토큰 리턴
     *
     * @memberof GameTokenTicket
     * @returns {string}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return this._token;
    }
  }]);
}(AbstractAuthTicket);
/** web token 티켓
 * @class
 */
var WebTokenTicket = /*#__PURE__*/function (_AbstractAuthTicket2) {
  function WebTokenTicket(token) {
    var _this16;
    _classCallCheck(this, WebTokenTicket);
    _this16 = _callSuper(this, WebTokenTicket);
    _this16._type = 'web_token';
    _this16._token = token;
    return _this16;
  }
  _inherits(WebTokenTicket, _AbstractAuthTicket2);
  return _createClass(WebTokenTicket, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * 토큰 리턴
     *
     * @memberof WebTokenTicket
     * @returns {string}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return this._token;
    }
  }]);
}(AbstractAuthTicket);
/** unknown token 티켓
 * @class
 */
var UnknownTokenTicket = /*#__PURE__*/function (_AbstractAuthTicket3) {
  function UnknownTokenTicket(token) {
    var _this17;
    _classCallCheck(this, UnknownTokenTicket);
    _this17 = _callSuper(this, UnknownTokenTicket);
    _this17._type = 'unknown_token';
    _this17._token = token;
    return _this17;
  }
  _inherits(UnknownTokenTicket, _AbstractAuthTicket3);
  return _createClass(UnknownTokenTicket, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * 토큰 리턴
     *
     * @memberof UnknownTokenTicket
     * @returns {string}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      console.error("cannot found token type for ".concat(this._token));
      return this._token;
    }
  }]);
}(AbstractAuthTicket);
/** web token 티켓
 * @class
 */
var ATokenTicket = /*#__PURE__*/function (_AbstractAuthTicket4) {
  function ATokenTicket(token) {
    var _this18;
    _classCallCheck(this, ATokenTicket);
    _this18 = _callSuper(this, ATokenTicket);
    _this18._type = 'a_token';
    _this18._token = token;
    return _this18;
  }
  _inherits(ATokenTicket, _AbstractAuthTicket4);
  return _createClass(ATokenTicket, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * 토큰 리턴
     *
     * @memberof ATokenTicket
     * @returns {string}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return this._token;
    }
  }]);
}(AbstractAuthTicket);
/** np token 티켓
 * @class
 */
var NpTokenTicket = /*#__PURE__*/function (_AbstractAuthTicket5) {
  function NpTokenTicket(token) {
    var _this19;
    _classCallCheck(this, NpTokenTicket);
    _this19 = _callSuper(this, NpTokenTicket);
    _this19._type = 'np_token';
    _this19._token = token;
    return _this19;
  }
  _inherits(NpTokenTicket, _AbstractAuthTicket5);
  return _createClass(NpTokenTicket, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * 토큰 리턴
     *
     * @memberof WebTokenTicket
     * @returns {string}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return this._token;
    }
  }]);
}(AbstractAuthTicket);
/** npp 티켓
 * @class
 */
var NppTicket = /*#__PURE__*/function (_AbstractAuthTicket6) {
  function NppTicket(token) {
    var _this20;
    _classCallCheck(this, NppTicket);
    _this20 = _callSuper(this, NppTicket);
    _this20._type = 'npp';
    _this20._token = token;
    return _this20;
  }
  _inherits(NppTicket, _AbstractAuthTicket6);
  return _createClass(NppTicket, [{
    key: "type",
    get: function get() {
      return this._type;
    }
  }, {
    key: "token",
    get: function get() {
      return this._token;
    }
    /**
     * 토큰 리턴
     *
     * @memberof NppTicket
     * @returns {string}
     */
  }, {
    key: "getValue",
    value: function getValue() {
      return this._token;
    }
  }]);
}(AbstractAuthTicket);
/** 인증 티켓 생성
 * @class
 */
var AuthTicketGenerator$1 = /*#__PURE__*/function () {
  function AuthTicketGenerator$1() {
    _classCallCheck(this, AuthTicketGenerator$1);
  }
  return _createClass(AuthTicketGenerator$1, null, [{
    key: "ByAToken",
    value:
    /**
     * aToken 티켓 인스턴스 리턴
     *
     * @memberof AuthTicketGenerator
     * @param {string} token 티켓 생성위한 토큰
     * @returns {ByAToken}
     */
    function ByAToken(token) {
      return new ATokenTicket(token);
    }
    /**
     * game-token 티켓 인스턴스 리턴
     *
     * @memberof AuthTicketGenerator
     * @param {string} token 티켓 생성위한 토큰
     * @returns {GameTokenTicket}
     */
  }, {
    key: "ByGameToken",
    value: function ByGameToken(token) {
      return new GameTokenTicket(token);
    }
    /**
     * np-token 티켓 인스턴스 리턴
     *
     * @memberof AuthTicketGenerator
     * @param {string} token 티켓 생성위한 토큰
     * @returns {NpTokenTicket}
     */
  }, {
    key: "ByNpToken",
    value: function ByNpToken(token) {
      return new NpTokenTicket(token);
    }
    /**
     * npp 티켓 인스턴스 리턴
     *
     * @memberof AuthTicketGenerator
     * @param {string} token 티켓 생성위한 토큰
     * @returns {NppTicket}
     */
  }, {
    key: "ByNpp",
    value: function ByNpp(token) {
      return new NppTicket(token);
    }
    /**
     * web-token 티켓 인스턴스 리턴
     *
     * @memberof AuthTicketGenerator
     * @param {string} token 티켓 생성위한 토큰
     * @returns {WebTokenTicket}
     */
  }, {
    key: "ByWebToken",
    value: function ByWebToken(token) {
      return new WebTokenTicket(token);
    }
    /**
     * np-token 티켓 인스턴스 리턴
     *
     * @memberof AuthTicketGenerator
     * @param {string} type 티켓 생성위한 토큰 타입
     * @param {string} token 티켓 생성위한 토큰
     * @returns {TokenTicket}
     */
  }, {
    key: "By",
    value: function By(_ref39) {
      var type = _ref39.type,
        token = _ref39.token;
      switch (type) {
        case 'a_token':
          return AuthTicketGenerator$1.ByAToken(token);
        case 'game_token':
          return AuthTicketGenerator$1.ByGameToken(token);
        case 'np_token':
          return AuthTicketGenerator$1.ByNpToken(token);
        case 'npp':
          return AuthTicketGenerator$1.ByNpp(token);
        case 'web_token':
          return AuthTicketGenerator$1.ByWebToken(token);
        default:
          return new UnknownTokenTicket(token);
      }
    }
  }]);
}();
var AuthTicketGenerator = AuthTicketGenerator$1;

/** LS 서버 웹소켓 HA 강화 관련 소켓 스위치 관리 모듈
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @class
 * @classdesc SDK 와 서버 프로토콜 간 통신소켓 관리 class
 */
var LivestreamSocket = /*#__PURE__*/function (_AbstractServiceSocke) {
  function LivestreamSocket() {
    var _this21;
    _classCallCheck(this, LivestreamSocket);
    _this21 = _callSuper(this, LivestreamSocket);
    _this21._url = '';
    _this21._asyncSendHandler = {};
    _this21._checkTimeoutHandler = {};
    _this21._onConnectHandler = null;
    _this21._subscribeList = []; // { path: '', stream: '', path_suffix: new Set([]) }

    _this21._negotiation = {
      pingTimeout: LS_ENUM.PING_TIMEOUT,
      pingIntalval: LS_ENUM.PING_INTERVAL_TIME,
      protocolTimeout: LS_ENUM.REQUEST_TIMEOUT_SECOND_MAX,
      retry: LS_ENUM.REQUEST_COUNT_MAX
    };
    /* Auth */

    _this21._cid = '';
    _this21._gid = '';
    _this21._lsAlias = '';
    _this21._path = '';
    _this21._webtoken = '';
    _this21._utoken = '';
    _this21._authTicket = AuthTicketGenerator.By({
      type: null,
      token: null
    });
    /* Protocol */

    _this21._healthcheckProtocol = new HealthcheckProtocol({
      socket: _this21
    });
    _this21._keepAliveProtocol = new KeepAliveProtocol({
      socket: _this21
    });
    _this21._protocolList = [_this21._healthcheckProtocol, _this21._keepAliveProtocol];
    _this21._controlProtocolEvent();
    return _this21;
  }
  _inherits(LivestreamSocket, _AbstractServiceSocke);
  return _createClass(LivestreamSocket, [{
    key: "url",
    get: function get() {
      return this._url;
    },
    set: function set(value) {
      if (value) this._url = value;
    }
  }, {
    key: "cid",
    get: function get() {
      return this._cid;
    },
    set: function set(value) {
      if (value) this._cid = value;
    }
  }, {
    key: "gid",
    get: function get() {
      return this._gid;
    },
    set: function set(value) {
      if (value) this._gid = value;
    }
  }, {
    key: "lsAlias",
    get: function get() {
      return this._lsAlias;
    },
    set: function set(value) {
      if (value) this._lsAlias = value;
    }
  }, {
    key: "utoken",
    get: function get() {
      return this._utoken;
    },
    set: function set(value) {
      if (value) this._utoken = value;
    }
  }, {
    key: "webToken",
    get: function get() {
      return this._webToken;
    },
    set: function set(value) {
      if (value) this._webToken = value;
    }
  }, {
    key: "authTicket",
    get: function get() {
      return this._authTicket;
    },
    set: function set(value) {
      if (value) this._authTicket = value;
    }
  }, {
    key: "negotiation",
    get: function get() {
      return this._negotiation;
    },
    set: function set(value) {
      if (value) this._negotiation = value;
    }
  }, {
    key: "_controlProtocolEvent",
    value: function _controlProtocolEvent() {
      var _this22 = this;
      this._healthcheckProtocol.event.addEventListener(WS_ENUM.EVENT.WS_PING_TIMEOUT, function () {
        _this22._keepAliveProtocol.event.dispatch(WS_ENUM.EVENT.WS_RECONNECT);
      });
      this.livestreamEvent.addEventListener(WS_ENUM.EVENT.MAINTENANCE, function (message) {
        _this22._keepAliveProtocol.event.dispatch(WS_ENUM.EVENT.WS_RECONNECT);
      });
    }
  }, {
    key: "_generateCReq",
    value: function _generateCReq() {
      return new Date().getTime();
    }
  }, {
    key: "_getMessageListener",
    value: function _getMessageListener(type) {
      return LivestreamMessageHook({}).hasOwnProperty(type) ? this.livestreamEvent : this.event;
    }
  }, {
    key: "_getMessageListenerName",
    value: function _getMessageListenerName(type) {
      var splitName = type.split(WS_ENUM.ACTION_SEPARATOR);
      return LivestreamMessageHook({}).hasOwnProperty(type) ? type : splitName[0];
    }
  }, {
    key: "_resetAllHandler",
    value: function _resetAllHandler() {
      for (var key in this._asyncSendHandler) {
        this._asyncSendHandler[key] = this.event.removeEventListener(this._asyncSendHandler[key]);
      }
      this._asyncSendHandler = {};
      for (var _key9 in this._checkTimeoutHandler) {
        this._checkTimeoutHandler[_key9] = clearInterval(this._checkTimeoutHandler[_key9]);
      }
      this._checkTimeoutHandler = {};
    }
  }, {
    key: "_resetCheckTimeoutHandler",
    value: function _resetCheckTimeoutHandler(id) {
      if (!id || !this._checkTimeoutHandler[id]) return;
      this._checkTimeoutHandler[id] = clearInterval(this._checkTimeoutHandler[id]);
      delete this._checkTimeoutHandler[id];
    }
  }, {
    key: "_resetAsyncSendHandler",
    value: function _resetAsyncSendHandler(id) {
      if (!id || !this._asyncSendHandler[id]) return;
      this._asyncSendHandler[id] = this.event.removeEventListener(this._asyncSendHandler[id]);
      delete this._asyncSendHandler[id];
    }
  }, {
    key: "_send",
    value: function _send(_ref40) {
      var type = _ref40.type,
        body = _ref40.body,
        _ref40$cReq = _ref40.cReq,
        cReq = _ref40$cReq === void 0 ? this._generateCReq() : _ref40$cReq;
      try {
        var payloadObj = {};
        payloadObj[WS_ENUM.KEY.TYPE] = type;
        payloadObj[WS_ENUM.KEY.BODY] = body;
        payloadObj[WS_ENUM.KEY.META] = {};
        payloadObj[WS_ENUM.KEY.META][WS_ENUM.KEY.CLIENT_REQUEST_TIME] = cReq;
        return this._emit(payloadObj);
      } catch (error) {
        throwLSError({
          error: error,
          payload: {
            type: type,
            body: body,
            cReq: cReq
          },
          name: 'FAILED_EMIT',
          type: 'emit'
        });
      }
    }
  }, {
    key: "_asyncSend",
    value: function _asyncSend(_ref41) {
      var _this23 = this;
      var type = _ref41.type,
        body = _ref41.body;
      return new Promise(function (resolve, reject) {
        var retryCount = 0;
        var cReq = _this23._generateCReq();
        cReq += _this23._checkTimeoutHandler[cReq] ? Math.floor(Math.random() * 100) : 0;
        try {
          /* emit 타임아웃 체크 */
          _this23._checkTimeoutHandler[cReq] = setInterval(function () {
            try {
              ++retryCount;
              if (retryCount > Number(_this23.negotiation.retry)) throwLSError({
                type: type,
                payload: body,
                name: 'SERVER_RESPONSE_TIMEOUT'
              });else if (_this23.isConnected) _this23._send({
                type: type,
                body: body,
                cReq: cReq
              });
            } catch (error) {
              _this23._resetCheckTimeoutHandler(cReq);
              _this23._resetAsyncSendHandler(cReq);
              reject(error);
            }
          }, _this23.negotiation.protocolTimeout);
          /* 서버 측에서 수신한 이벤트에 대한 리스너 */

          var event = _this23._getMessageListener(type);
          var listenerName = _this23._getMessageListenerName(type);
          _this23._asyncSendHandler[cReq] = event.addEventListener(listenerName, function (message) {
            if (message && message.meta && message.meta[WS_ENUM.KEY.CLIENT_REQUEST_TIME] === cReq) {
              _this23._resetCheckTimeoutHandler(cReq);
              _this23._resetAsyncSendHandler(cReq);
              resolve(_extends({}, message));
            }
          });
          /* 이벤트 전송 */

          var result = _this23._send({
            type: type,
            body: body,
            cReq: cReq
          });
          if (result && result.CODE === 111208) throw result;
        } catch (error) {
          _this23._resetCheckTimeoutHandler(cReq);
          _this23._resetAsyncSendHandler(cReq);
          reject(error);
        }
      });
    }
  }, {
    key: "_addSubscribeReqBody",
    value: function _addSubscribeReqBody(_ref42) {
      var path = _ref42.path,
        path_suffix = _ref42.path_suffix,
        stream = _ref42.stream;
      var body = {
        stream: stream
      };
      var pathWithString = path.toString();
      /* subscribe, subscribe_with_suffix 분기 처리 */

      if (!path_suffix || !path_suffix.length && !path_suffix.size) {
        this._subscribeList = addSubscribeListOnlyPath({
          stream: stream,
          path: pathWithString,
          subscribeList: this._subscribeList
        });
        body.path = [pathWithString];
      } else {
        this._subscribeList = addSubscribeList({
          stream: stream,
          path: pathWithString,
          path_suffix: path_suffix,
          subscribeList: this._subscribeList
        });
        body.path = pathWithString;
        body.path_suffix = Array.isArray(path_suffix) ? path_suffix : Array.from(path_suffix);
      }
      return body;
    }
  }, {
    key: "_removeSubscribeReqBody",
    value: function _removeSubscribeReqBody(_ref43) {
      var path = _ref43.path,
        path_suffix = _ref43.path_suffix,
        stream = _ref43.stream;
      var body = {
        stream: stream
      };
      var pathWithString = path.toString();
      /* subscribe, subscribe_with_suffix 분기 처리 */

      if (!path_suffix || !path_suffix.length) {
        this._subscribeList = removeSubscribeListOnlyPath({
          stream: stream,
          path: pathWithString,
          subscribeList: this._subscribeList
        });
        body.path = [pathWithString];
      } else {
        this._subscribeList = removeSubscribeList({
          stream: stream,
          path: pathWithString,
          path_suffix: path_suffix,
          subscribeList: this._subscribeList
        });
        body.path = pathWithString;
        body.path_suffix = path_suffix;
      }
      return body;
    }
    /**
     * 웹소켓: 메시지 수신
     *
     * @memberof LivestreamSocket
     * @param {Object} message 소켓 서버로부터 수신한 메세지
     */
  }, {
    key: "onMessage",
    value: function onMessage(message) {
      try {
        var compiledMessage = compileResponse({
          res: message
        });
        if (LivestreamMessageHook({}).hasOwnProperty(compiledMessage.type)) LivestreamMessageHook({
          socket: this
        })[compiledMessage.type](compiledMessage);else GeneralMessageHook({
          socket: this,
          message: compiledMessage
        });
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: 연결 수신
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "onConnect",
    value: function onConnect() {
      var _this24 = this;
      try {
        this.livestreamEvent.dispatch(WS_ENUM.EVENT.WS_CONNECT);
        this._onConnectHandler = this.livestreamEvent.addEventListener(WS_ENUM.EVENT.CONNECT, function () {
          _this24._protocolList.map(function (protocol) {
            return protocol.end();
          });
          _this24._protocolList.map(function (protocol) {
            return protocol.start();
          });
          _this24.livestreamEvent.removeEventListener(_this24._onConnectHandler);
          _this24._onConnectHandler = null;
        });
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: 연결 해제 수신
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "onDisconnect",
    value: function onDisconnect() {
      try {
        this.livestreamEvent.dispatch(WS_ENUM.EVENT.WS_DISCONNECT);
        this._resetAllHandler();
        setCIDIntoPool({
          namespacePath: this.gid,
          cid: this.cid
        });
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: Ping 수신
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "onPing",
    value: function onPing() {
      try {
        this.livestreamEvent.dispatch(WS_ENUM.EVENT.WS_PING);
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: Pong 수신
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "onPong",
    value: function onPong() {
      try {
        this.livestreamEvent.dispatch(WS_ENUM.EVENT.WS_PONG);
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: 에러 수신
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "onError",
    value: function onError(error) {
      try {
        var errorInstance = socketError({
          error: error
        });
        this.livestreamEvent.dispatch(WS_ENUM.EVENT.WS_ERROR, error);
        if (errorInstance) {
          this._keepAliveProtocol.event.dispatch(WS_ENUM.EVENT.WS_RECONNECT);
        }
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: 연결
     *
     * @memberof LivestreamSocket
     * @param {string} url
     * @param {string} option URL 파라미터 옵션
     */
  }, {
    key: "connect",
    value: function connect(url, option) {
      try {
        var query = option && option instanceof ServiceParam ? option.toURLQuery() : '';
        this.url = url + (!!query ? "?".concat(query) : '');
        this._connect(this.url);
      } catch (error) {
        throwLSError({
          error: error,
          payload: {
            url: url,
            option: option
          },
          name: 'FAILED_INIT_WS',
          type: WS_ENUM.EVENT.CONNECT
        });
      }
    }
    /**
     * 웹소켓: 연결 해제
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "disconnect",
    value: function disconnect() {
      var eventType = WS_ENUM.EVENT.DISCONNECT;
      try {
        this._disconnect();
        this.event.dispatch(eventType); // 사용자 연결 종료 disconnect와 웹소켓 연결종료 ws::disconnect는 별도로 이벤트가 발생함
      } catch (error) {
        throwLSError({
          error: error,
          name: 'FAILED_DISCONNECT_WS',
          type: eventType
        });
      }
    }
    /**
     * 서비스 연결 해제가 아니라 이 연결 자체를 무효화한다.
     * 사용자에 의한 강제 finalize 및 강제 연결 해제
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "drop",
    value: function drop() {
      try {
        var protocolEnd = this._protocolList.map(function (protocol) {
          return protocol.end();
        });
        this._drop();
      } catch (error) {
        DEBUG.error(error);
      }
    }
    /**
     * 웹소켓: ping
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "ping",
    value: function ping() {
      this._wsPing();
    }
    /**
     * 웹소켓: gid 등록
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "addGID",
    value: function addGID(_ref44) {
      var gid = _ref44.gid,
        webToken = _ref44.webToken;
      var _this = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(resolve, reject) {
          var stringGID, message;
          return _regeneratorRuntime().wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                if (!gid || !webToken) reject();
                stringGID = gid.toString();
                _context8.next = 5;
                return _this._asyncSend({
                  type: WS_ENUM.EVENT.ADD_GID_BY_WEB_TOKEN,
                  body: {
                    gid: stringGID,
                    web_token: webToken
                  }
                });
              case 5:
                message = _context8.sent;
                if (message.error) reject(message.error);else resolve(_extends({}, message));
                _context8.next = 12;
                break;
              case 9:
                _context8.prev = 9;
                _context8.t0 = _context8["catch"](0);
                reject(_context8.t0);
              case 12:
              case "end":
                return _context8.stop();
            }
          }, _callee8, null, [[0, 9]]);
        }));
        return function (_x6, _x7) {
          return _ref45.apply(this, arguments);
        };
      }());
    }
    /**
     * 웹소켓: utoken 요청
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "createUtoken",
    value: function createUtoken(_ref46) {
      var accessToken = _ref46.accessToken,
        accessTokenType = _ref46.accessTokenType;
      var _this2 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(resolve, reject) {
          var message;
          return _regeneratorRuntime().wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                if (!accessToken || !accessTokenType) reject();
                _this2.authTicket = AuthTicketGenerator.By({
                  type: accessTokenType,
                  token: accessToken
                });
                _context9.next = 5;
                return _this2._asyncSend({
                  type: WS_ENUM.EVENT.CREATE_UTOKEN,
                  body: {
                    access_token: accessToken,
                    access_token_type: accessTokenType
                  }
                });
              case 5:
                message = _context9.sent;
                if (!message.error) {
                  _context9.next = 8;
                  break;
                }
                return _context9.abrupt("return", reject(message.error));
              case 8:
                resolve(_extends({}, message));
                _context9.next = 16;
                break;
              case 11:
                _context9.prev = 11;
                _context9.t0 = _context9["catch"](0);
                _this2.utoken = null;
                if (_this2.authTicket && _this2.authTicket.token) _this2.authTicket = AuthTicketGenerator.By({
                  type: null,
                  token: null
                });
                reject(_context9.t0);
              case 16:
              case "end":
                return _context9.stop();
            }
          }, _callee9, null, [[0, 11]]);
        }));
        return function (_x8, _x9) {
          return _ref47.apply(this, arguments);
        };
      }());
    }
    /**
     * 웹소켓: 인증
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "authByUtoken",
    value: function authByUtoken(_ref48) {
      var utoken = _ref48.utoken,
        accessToken = _ref48.accessToken,
        accessTokenType = _ref48.accessTokenType;
      var _this3 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(resolve, reject) {
          var message;
          return _regeneratorRuntime().wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                if (!utoken) reject();
                if (!_this3.authTicket || _this3.authTicket.type === 'unknown_token' && accessToken && accessTokenType) _this3.authTicket = AuthTicketGenerator.By({
                  type: accessTokenType,
                  token: accessToken
                });
                _context10.next = 5;
                return _this3._asyncSend({
                  type: WS_ENUM.EVENT.AUTH,
                  body: {
                    utoken: utoken
                  }
                });
              case 5:
                message = _context10.sent;
                if (message.error) reject(message.error);else resolve(_extends({}, message));
                _context10.next = 14;
                break;
              case 9:
                _context10.prev = 9;
                _context10.t0 = _context10["catch"](0);
                _this3.utoken = null;
                if (_this3.authTicket && _this3.authTicket.token) _this3.authTicket = AuthTicketGenerator.By({
                  type: null,
                  token: null
                });
                reject(_context10.t0);
              case 14:
              case "end":
                return _context10.stop();
            }
          }, _callee10, null, [[0, 9]]);
        }));
        return function (_x10, _x11) {
          return _ref49.apply(this, arguments);
        };
      }());
    }
    /**
     * 웹소켓: 구독
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "subscribe",
    value: function subscribe(_ref50) {
      var path = _ref50.path,
        path_suffix = _ref50.path_suffix,
        stream = _ref50.stream;
      var _this4 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee11(resolve, reject) {
          var body, eventType, message;
          return _regeneratorRuntime().wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                if (!stream || !path) reject();
                body = _this4._addSubscribeReqBody({
                  path: path,
                  path_suffix: path_suffix,
                  stream: stream
                });
                eventType = body.stream + WS_ENUM.ACTION_SEPARATOR + WS_ENUM.EVENT['SUBSCRIBE' + (body.path_suffix ? '_WITH_SUFFIX' : '')];
                _context11.next = 6;
                return _this4._asyncSend({
                  type: eventType,
                  body: body
                });
              case 6:
                message = _context11.sent;
                if (message.error) reject(message.error);else resolve(_extends({}, message));
                _context11.next = 13;
                break;
              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);
                reject(_context11.t0);
              case 13:
              case "end":
                return _context11.stop();
            }
          }, _callee11, null, [[0, 10]]);
        }));
        return function (_x12, _x13) {
          return _ref51.apply(this, arguments);
        };
      }());
    }
    /**
     * 웹소켓: 구독 해제
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "unsubscribe",
    value: function unsubscribe(_ref52) {
      var path = _ref52.path,
        path_suffix = _ref52.path_suffix,
        stream = _ref52.stream;
      var _this5 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee12(resolve, reject) {
          var body, eventType, message;
          return _regeneratorRuntime().wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                if (!stream || !path) reject();
                body = _this5._removeSubscribeReqBody({
                  path: path,
                  path_suffix: path_suffix,
                  stream: stream
                });
                eventType = body.stream + WS_ENUM.ACTION_SEPARATOR + WS_ENUM.EVENT['UNSUBSCRIBE' + (body.path_suffix ? '_WITH_SUFFIX' : '')];
                _context12.next = 6;
                return _this5._asyncSend({
                  type: eventType,
                  body: body
                });
              case 6:
                message = _context12.sent;
                if (message.error) reject(message.error);else resolve(_extends({}, message));
                _context12.next = 13;
                break;
              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](0);
                reject(_context12.t0);
              case 13:
              case "end":
                return _context12.stop();
            }
          }, _callee12, null, [[0, 10]]);
        }));
        return function (_x14, _x15) {
          return _ref53.apply(this, arguments);
        };
      }());
    }
    /**
     * 웹소켓: protobuf 타입 데이터 전송
     *
     * @memberof LivestreamSocket
     */
  }, {
    key: "sendByProtobuf",
    value: function sendByProtobuf(_ref54) {
      var body = _ref54.body;
      var _this6 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee13(resolve, reject) {
          var message;
          return _regeneratorRuntime().wrap(function _callee13$(_context13) {
            while (1) switch (_context13.prev = _context13.next) {
              case 0:
                try {
                  message = _this6._asyncSend({
                    type: WS_ENUM.EVENT.PROTOBUF,
                    body: body
                  });
                  if (message.error) reject(message.error);else resolve(_extends({}, message));
                } catch (error) {
                  reject(error);
                }
              case 1:
              case "end":
                return _context13.stop();
            }
          }, _callee13);
        }));
        return function (_x16, _x17) {
          return _ref55.apply(this, arguments);
        };
      }());
    }
  }]);
}(AbstractServiceSocket);
/** 소켓 박스
 * @class
 */
var SocketBox$1 = /*#__PURE__*/function () {
  function SocketBox$1() {
    _classCallCheck(this, SocketBox$1);
  }
  return _createClass(SocketBox$1, null, [{
    key: "_getLSServiceSocket",
    value: function _getLSServiceSocket() {
      if (typeof window !== 'undefined') {
        if (!window._livestream_serviceSocket) {
          window._livestream_serviceSocket = null;
        }
        return window._livestream_serviceSocket;
      } else {
        if (!global._livestream_serviceSocket) {
          global._livestream_serviceSocket = null;
        }
        return global._livestream_serviceSocket;
      }
    }
  }, {
    key: "_addLSSocket",
    value: function _addLSSocket(socket) {
      if (typeof window !== 'undefined') {
        window._livestream_serviceSocket = socket;
      } else if (!global._livestream_serviceSocket) {
        global._livestream_serviceSocket = socket;
      }
    }
    /**
     * GET 라이브스트림 소켓
     *
     * @memberof SocketBox
     * @returns {Socket}
     */
  }, {
    key: "getLSSocket",
    value: function getLSSocket(_ref) {
      var args = _extends({}, _ref);
      var livestreamSock = SocketBox$1._getLSServiceSocket();
      if (!livestreamSock) {
        var socket = new LivestreamSocket(_extends({}, args));
        SocketBox$1._addLSSocket(socket);
        return socket;
      }
      return livestreamSock;
    }
    /**
     * 라이브스트림 소켓을 제거하여 다음 소켓 생성시 새로운 소켓/이벤트로 연결이 가능하도록 한다
     *
     * @static
     * @memberof SocketBox
     */
  }, {
    key: "dropLSSocket",
    value: function dropLSSocket() {
      if (typeof window !== 'undefined') {
        var socket = window._livestream_serviceSocket;
        window._livestream_serviceSocket = null;
        if (socket) {
          socket.drop();
        }
      } else {
        var _socket = global._livestream_serviceSocket;
        global._livestream_serviceSocket = null;
        if (_socket) {
          _socket.drop();
        }
      }
    }
    /**
     * 각 소켓 모듈이 참조하는 이벤트 리스너를 추가 합니다.
     *
     * @static
     * @memberof SocketBox
     */
  }, {
    key: "addEventListener",
    value: function addEventListener(stream, listenerCB) {
      if (!SocketBox$1._LSEventList) {
        SocketBox$1._LSEventList = [];
      }
      var filteredList = SocketBox$1._LSEventList.filter(function (_ref56) {
        var callback = _ref56.callback;
        return listenerCB === callback;
      });
      if (!filteredList.length) {
        SocketBox$1._LSEventList.push({
          stream: stream,
          callback: listenerCB
        });
      }
      var ws = SocketBox$1.getLSSocket({});
      return ws.event.addEventListener(stream, listenerCB);
    }
    /**
     * 리스트의 모든 리스너를 등록 합니다.
     *
     * @static
     * @memberof SocketBox
     */
  }, {
    key: "addEventListenerAll",
    value: function addEventListenerAll() {
      if (!SocketBox$1._LSEventList) {
        SocketBox$1._LSEventList = [];
      } else {
        SocketBox$1._LSEventList.forEach(function (_ref57) {
          var stream = _ref57.stream,
            callback = _ref57.callback;
          SocketBox$1.addEventListener(stream, callback);
        });
      }
    }
    /**
     * 리스트에서 이벤트 리스너를 제거 합니다.
     *
     * @static
     * @memberof SocketBox
     */
  }, {
    key: "removeEventListener",
    value: function removeEventListener(listenerCB) {
      if (!SocketBox$1._LSEventList) {
        return;
      }
      SocketBox$1._LSEventList = SocketBox$1._LSEventList.filter(function (_ref58) {
        var callback = _ref58.callback;
        return listenerCB !== callback;
      });
      var ws = SocketBox$1.getLSSocket({});
      ws.event.removeEventListener(listenerCB);
    }
  }]);
}();
var SocketBox = SocketBox$1;

/** 라이브스트림 SDK ~ LS 서버 통신 모듈
 * @author 박희용 <huiyongPark@nexon.co.kr>
 * @class
 * @classdesc SDK 와 서버 프로토콜 간 통신 인터페이스 classs
 */
var LivestreamManager = /*#__PURE__*/function () {
  function LivestreamManager() {
    _classCallCheck(this, LivestreamManager);
    this._setInfo();
  }
  return _createClass(LivestreamManager, [{
    key: "version",
    get: function get() {
      return ENV.LIVE_STREAM_VERSION({
        env: this.env
      });
    }
  }, {
    key: "info",
    get: function get() {
      return {
        cid: this.ws.cid,
        ls_alias: this.ws.lsAlias,
        utoken: this.ws.utoken,
        path: this.path
      };
    }
  }, {
    key: "ws",
    get: function get() {
      return SocketBox.getLSSocket({});
    }
  }, {
    key: "env",
    get: function get() {
      return this._env;
    },
    set: function set(value) {
      if (value) {
        var env = value.trim().toLowerCase();
        if (ENV.LIST.includes(env)) this._env = env;
      }
    }
  }, {
    key: "path",
    get: function get() {
      return this._path;
    },
    set: function set(value) {
      if (value) this._path = value;
    }
  }, {
    key: "status",
    get: function get() {
      return this._status;
    },
    set: function set(value) {
      if (value) this._status = value;
    }
  }, {
    key: "_setInfo",
    value: function _setInfo() {
      this._status = LS_ENUM.STATUS.STOP;
      this._env = InfaceEnv.value.env || ENV.LIVE;
      this._path = null;
    }
  }, {
    key: "_setDebug",
    value: function _setDebug(payload) {
      if (payload.debug) {
        DEBUG.USE = payload.debug.use && typeof payload.debug.use === 'boolean' ? payload.debug.use : false;
        DEBUG.LEVEL = payload.debug.level && typeof Number(payload.debug.level) === 'number' && payload.debug.level >= DEBUG.MIN_LEVEL && payload.debug.level <= DEBUG.MAX_LEVEL ? Number(payload.debug.level) : DEBUG.MIN_LEVEL;
      }
    }
  }, {
    key: "_updateModuleStatus",
    value: function _updateModuleStatus(status) {
      if (!status || !LS_ENUM.STATUS[status.toUpperCase()]) return false;
      this.status = LS_ENUM.STATUS[status.toUpperCase()];
      this.ws.event.dispatch(this.status, {
        status: status
      });
    }
    /**
     * @memberof LivestreamManager
     * @param {Object} payload 클라이언트 전달 페이로드
     * LS 서버 웹소켓 연결
     */
  }, {
    key: "_connect",
    value: function _connect(payload) {
      var _this = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee14(resolve, reject) {
          var checkCid, _connectHandler, url, option;
          return _regeneratorRuntime().wrap(function _callee14$(_context14) {
            while (1) switch (_context14.prev = _context14.next) {
              case 0:
                checkCid = null;
                _context14.prev = 1;
                _connectHandler = _this.ws.livestreamEvent.addEventListener(WS_ENUM.EVENT.WS_CONNECT, function () {
                  /* cid 체크 인터벌 */
                  var checkTime = 0;
                  checkCid = setInterval(function () {
                    if (_this.status === LS_ENUM.STATUS.STOP) {
                      clearInterval(checkCid);
                      _this.ws.livestreamEvent.removeEventListener(_connectHandler);
                    }
                    if (!_this.ws.cid && checkTime === LS_ENUM.CHECK_CID_TIMEOUT_SECOND_MAX) {
                      clearInterval(checkCid);
                      var errorInstacne = getErrorInstance({
                        event: WS_ENUM.EVENT.CONNECT,
                        payload: payload,
                        name: 'FAILED_GET_CID'
                      });
                      _this.ws.livestreamEvent.removeEventListener(_connectHandler);
                      reject(errorInstacne);
                    } else if (_this.ws.cid) {
                      clearInterval(checkCid);
                      _this.path = payload.path;
                      _this.ws.livestreamEvent.removeEventListener(_connectHandler);
                      resolve();
                    }
                    checkTime += LS_ENUM.CHECK_CID_TIMEOUT_SECOND;
                  }, LS_ENUM.CHECK_CID_TIMEOUT_SECOND);
                });
                url = ENV.URL({
                  env: _this.env
                });
                _context14.next = 6;
                return generateUrlOption({
                  path: payload.path,
                  cid: payload.cid
                });
              case 6:
                option = _context14.sent;
                _this.ws.connect(url, option);
                _context14.next = 15;
                break;
              case 10:
                _context14.prev = 10;
                _context14.t0 = _context14["catch"](1);
                clearInterval(checkCid);
                checkCid = null;
                reject(_context14.t0);
              case 15:
              case "end":
                return _context14.stop();
            }
          }, _callee14, null, [[1, 10]]);
        }));
        return function (_x18, _x19) {
          return _ref59.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_createUtoken",
    value: function _createUtoken(_ref60) {
      var access_token = _ref60.access_token,
        access_token_type = _ref60.access_token_type;
      var _this2 = this;
      var eventType = WS_ENUM.EVENT.CREATE_UTOKEN;
      throwLSError({
        payload: {
          accessToken: access_token
        },
        name: 'INVALID_ACCESS_TOKEN',
        type: eventType
      });
      throwLSError({
        payload: {
          accessTokenType: access_token_type
        },
        name: 'INVALID_ACCESS_TOKEN_TYPE',
        type: eventType
      });
      var accessToken = access_token.trim();
      var accessTokenType = access_token_type.trim();
      return new Promise( /*#__PURE__*/function () {
        var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee15(resolve, reject) {
          var _yield$_this2$ws$crea, type, body, meta, errorInstacne;
          return _regeneratorRuntime().wrap(function _callee15$(_context15) {
            while (1) switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                _context15.next = 3;
                return _this2.ws.createUtoken({
                  accessToken: accessToken,
                  accessTokenType: accessTokenType
                });
              case 3:
                _yield$_this2$ws$crea = _context15.sent;
                type = _yield$_this2$ws$crea.type;
                body = _yield$_this2$ws$crea.body;
                meta = _yield$_this2$ws$crea.meta;
                resolve({
                  type: type,
                  body: body,
                  meta: meta
                });
                _context15.next = 14;
                break;
              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](0);
                errorInstacne = getErrorInstance({
                  event: eventType,
                  payload: {
                    access_token: access_token,
                    access_token_type: access_token_type
                  },
                  name: 'FAILED_CREATE_UTOKEN',
                  error: _context15.t0
                });
                reject(errorInstacne);
              case 14:
              case "end":
                return _context15.stop();
            }
          }, _callee15, null, [[0, 10]]);
        }));
        return function (_x20, _x21) {
          return _ref61.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_authByUtoken",
    value: function _authByUtoken(_ref62) {
      var access_token = _ref62.access_token,
        access_token_type = _ref62.access_token_type;
      var _this3 = this;
      var eventType = WS_ENUM.EVENT.AUTH;
      var utoken = this.ws.utoken;
      throwLSError({
        payload: {
          utoken: utoken
        },
        name: 'INVALID_UTOKEN',
        type: eventType
      });
      var accessToken = access_token ? access_token.trim() : null;
      var accessTokenType = access_token_type ? access_token_type.trim() : null;
      return new Promise( /*#__PURE__*/function () {
        var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee16(resolve, reject) {
          var _yield$_this3$ws$auth, type, body, meta, errorInstacne;
          return _regeneratorRuntime().wrap(function _callee16$(_context16) {
            while (1) switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                _context16.next = 3;
                return _this3.ws.authByUtoken({
                  utoken: utoken,
                  accessToken: accessToken,
                  accessTokenType: accessTokenType
                });
              case 3:
                _yield$_this3$ws$auth = _context16.sent;
                type = _yield$_this3$ws$auth.type;
                body = _yield$_this3$ws$auth.body;
                meta = _yield$_this3$ws$auth.meta;
                resolve({
                  type: type,
                  body: body,
                  meta: meta
                });
                _context16.next = 14;
                break;
              case 10:
                _context16.prev = 10;
                _context16.t0 = _context16["catch"](0);
                errorInstacne = getErrorInstance({
                  event: eventType,
                  payload: {
                    utoken: utoken
                  },
                  name: 'FAILED_AUTH_TO_SERVER',
                  error: _context16.t0
                });
                reject(errorInstacne);
              case 14:
              case "end":
                return _context16.stop();
            }
          }, _callee16, null, [[0, 10]]);
        }));
        return function (_x22, _x23) {
          return _ref63.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "_getUID",
    value: function _getUID(_ref64) {
      var access_token = _ref64.access_token,
        accessToken = _ref64.accessToken;
      var token = access_token || accessToken;
      var uid = token ? extractUIDFromToken({
        token: token
      }) : null;
      return uid;
    }
  }, {
    key: "_optimizeUtoken",
    value: function () {
      var _optimizeUtoken2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee17(_ref65) {
        var uid;
        return _regeneratorRuntime().wrap(function _callee17$(_context17) {
          while (1) switch (_context17.prev = _context17.next) {
            case 0:
              uid = _ref65.uid;
              if (!(this.ws.utoken || uid)) {
                _context17.next = 7;
                break;
              }
              _context17.next = 4;
              return getUtokenFromPool({
                uid: uid
              });
            case 4:
              _context17.t0 = _context17.sent;
              _context17.next = 8;
              break;
            case 7:
              _context17.t0 = null;
            case 8:
              this.ws.utoken = _context17.t0;
            case 9:
            case "end":
              return _context17.stop();
          }
        }, _callee17, this);
      }));
      function _optimizeUtoken(_x24) {
        return _optimizeUtoken2.apply(this, arguments);
      }
      return _optimizeUtoken;
    }()
  }, {
    key: "_isAvailableRestart",
    value: function _isAvailableRestart(payload) {
      return this.status === LS_ENUM.STATUS.START && (!!payload.env && payload.env !== this.env || !!this.path && payload.path !== this.path);
    }
    /**
     * @memberof LivestreamManager
     * @param {Object} payload SDK 초기화에 필요한 데이터 수신
     * @param {string} payload.path 게임명 (gid, path)
     * @param {string} [payload.cid] cid
     * @param {string} [payload.access_token] 인증 토큰
     * @param {string} [payload.access_token_type]  인증 토큰 타입
     * @param {string} [payload.env] 환경변수
     * @param {Object} [payload.debug] 디버그 모드
     * @param {boolean} [payload.debug.use] 디버그 모드 사용
     * @param {number} [payload.debug.level] 디버그 모드 레벨
     * @description
     * LS SDK 초기화<br><br>
     * 초기화 과정<br>
     * 1. connect<br>
     * 2. subscribe (옵션)<br>
     * 3. auth (옵션)<br>
     */
  }, {
    key: "initialize",
    value: function initialize(payload) {
      var _this4 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee18(resolve, reject) {
          var eventType, errorObject, _iterator5, _step5, item, compiledItem, result, errorInstance;
          return _regeneratorRuntime().wrap(function _callee18$(_context18) {
            while (1) switch (_context18.prev = _context18.next) {
              case 0:
                eventType = LS_ENUM.INTERFACE.INITIALIZE;
                errorObject = {};
                _context18.prev = 2;
                if (!_this4._isAvailableRestart(payload)) {
                  _context18.next = 9;
                  break;
                }
                _context18.next = 6;
                return _this4._asyncFinalize();
              case 6:
                SocketBox.addEventListenerAll();
                _context18.next = 10;
                break;
              case 9:
                throwLSError({
                  payload: _extends({
                    status: _this4.status
                  }, payload),
                  name: 'DUPLICATED_INITIALIZE',
                  type: eventType
                });
              case 10:
                // ENV, path(gid) 값 변경 시, 재연결 허용

                throwLSError({
                  payload: payload,
                  name: 'INVALID_PATH',
                  type: eventType
                });
                _this4.env = payload.env;
                _this4._setDebug(payload);
                _this4._updateModuleStatus(LS_ENUM.STATUS.STANDBY);
                DEBUG.status(_this4.status, payload);
                /* 1. 소켓 연결 */
                _context18.prev = 15;
                _context18.next = 18;
                return _this4._connect(payload);
              case 18:
                _context18.next = 23;
                break;
              case 20:
                _context18.prev = 20;
                _context18.t0 = _context18["catch"](15);
                throwLSError({
                  payload: payload,
                  name: 'FAILED_CONNECT_WS',
                  type: eventType,
                  error: _context18.t0
                });
              case 23:
                _this4._updateModuleStatus(LS_ENUM.STATUS.START);
                DEBUG.status(_this4.status);
                /* 2. 구독 (옵션) */

                try {
                  if (_this4.subscribeList && _this4.subscribeList.length) {
                    _iterator5 = _createForOfIteratorHelper(_this4.subscribeList);
                    try {
                      for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                        item = _step5.value;
                        compiledItem = item;
                        if (compiledItem.path_suffix && compiledItem.path_suffix.length) compiledItem.path_suffix = _toConsumableArray(compiledItem.path_suffix);
                        _this4.subscribe(compiledItem);
                      }
                    } catch (err) {
                      _iterator5.e(err);
                    } finally {
                      _iterator5.f();
                    }
                  }
                } catch (error) {
                  errorObject[error.name] = _extends({}, error);
                }
                /* 3. 인증 (옵션) */
                _context18.prev = 26;
                if (!(_this4.ws.cid && payload.access_token && payload.access_token_type)) {
                  _context18.next = 30;
                  break;
                }
                _context18.next = 30;
                return _this4.attachAuth(payload);
              case 30:
                _context18.next = 35;
                break;
              case 32:
                _context18.prev = 32;
                _context18.t1 = _context18["catch"](26);
                errorObject[_context18.t1.name] = _extends({}, _context18.t1);
              case 35:
                result = {
                  status: 'success',
                  cid: _this4.ws.cid,
                  ls_alias: _this4.ws.lsAlias
                };
                if (_this4.ws.utoken) result.utoken = _this4.ws.utoken;
                if (Object.keys(errorObject).length) result[LS_ENUM.SUB_ERROR] = errorObject;
                resolve(result);
                _context18.next = 47;
                break;
              case 41:
                _context18.prev = 41;
                _context18.t2 = _context18["catch"](2);
                if (!_context18.t2 || _context18.t2.code !== LS_ERR.DUPLICATED_INITIALIZE.CODE || _context18.t2.code !== LS_ERR.INVALID_PATH || _context18.t2.code !== LS_ERR.INVALID_PATH) _this4.finalize(); // 모듈 중복 실행 요청 시, 기존 모듈 종료 방지
                errorInstance = getErrorInstance({
                  event: eventType,
                  payload: payload,
                  error: _context18.t2,
                  name: 'FAILED_INIT_PROCESS'
                });
                errorInstance.name = eventType;
                reject(errorInstance);
              case 47:
              case "end":
                return _context18.stop();
            }
          }, _callee18, null, [[2, 41], [15, 20], [26, 32]]);
        }));
        return function (_x25, _x26) {
          return _ref66.apply(this, arguments);
        };
      }());
    }
    /**
     * G(U)ID 등록
     *
     * @memberof LivestreamManager
     * @param {Object} payload GID 등록에 필요한 데이터 수신
     * @param {String} gid
     * @param {String} web_token
     */
  }, {
    key: "addGID",
    value: function addGID(payload) {
      var _this5 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee19(resolve, reject) {
          var eventType, result, errorInstance;
          return _regeneratorRuntime().wrap(function _callee19$(_context19) {
            while (1) switch (_context19.prev = _context19.next) {
              case 0:
                eventType = LS_ENUM.INTERFACE.ADD_GID;
                _context19.prev = 1;
                throwLSError({
                  payload: _extends({
                    status: _this5.status
                  }, payload),
                  name: 'SDK_DID_NOT_START',
                  type: eventType
                });
                throwLSError({
                  payload: _extends({}, payload),
                  name: 'INVALID_GID',
                  type: eventType
                });
                throwLSError({
                  payload: _extends({}, payload),
                  name: 'INVALID_WEB_TOKEN',
                  type: eventType
                });
                _context19.next = 7;
                return _this5.ws.addGID({
                  gid: payload.gid,
                  webToken: payload.webToken || payload.web_token
                });
              case 7:
                result = _context19.sent;
                resolve(result);
                _context19.next = 16;
                break;
              case 11:
                _context19.prev = 11;
                _context19.t0 = _context19["catch"](1);
                errorInstance = getErrorInstance({
                  payload: payload,
                  error: _context19.t0,
                  name: 'FAILED_ADD_GID',
                  event: eventType
                });
                errorInstance.name = eventType;
                reject(errorInstance);
              case 16:
              case "end":
                return _context19.stop();
            }
          }, _callee19, null, [[1, 11]]);
        }));
        return function (_x27, _x28) {
          return _ref67.apply(this, arguments);
        };
      }());
    }
    /**
     * LS 인증
     *
     * @memberof LivestreamManager
     * @param {Object} payload 인증에 필요한 데이터 수신
     * @description
     * 1. token 으로 부터 uid 추출
     * 2-A. 소켓에 utoken 존재 시, auth() 진행
     * 2-B. 소켓에 utoken 미존재 시, uid를 key로 pool에서 utoken 추출 후, auth() 진행
     * 2-C. 소켓, pool에 utoken 미존재 시, createUtoken() 진행
     * 3. uid를 key로 pool에 utoken 저장
     */
  }, {
    key: "attachAuth",
    value: function attachAuth(payload) {
      var _this6 = this;
      return new Promise( /*#__PURE__*/function () {
        var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee20(resolve, reject) {
          var eventType, uid, result, errorInstance;
          return _regeneratorRuntime().wrap(function _callee20$(_context20) {
            while (1) switch (_context20.prev = _context20.next) {
              case 0:
                eventType = LS_ENUM.INTERFACE.ATTACH_AUTH;
                _context20.prev = 1;
                throwLSError({
                  payload: _extends({
                    status: _this6.status
                  }, payload),
                  name: 'SDK_DID_NOT_START',
                  type: eventType
                });
                uid = _this6._getUID(payload);
                _context20.next = 6;
                return _this6._optimizeUtoken({
                  uid: uid
                });
              case 6:
                if (_this6.ws.utoken) {
                  _context20.next = 27;
                  break;
                }
                _context20.prev = 7;
                _context20.next = 10;
                return _this6._createUtoken(payload);
              case 10:
                _context20.next = 25;
                break;
              case 12:
                _context20.prev = 12;
                _context20.t0 = _context20["catch"](7);
                getErrorInstance({
                  payload: payload,
                  error: _context20.t0,
                  name: 'FAILED_CREATE_UTOKEN',
                  event: eventType
                });
                _context20.next = 17;
                return setUtokenInPool({
                  uid: uid,
                  utoken: null
                });
              case 17:
                _context20.prev = 17;
                _context20.next = 20;
                return _this6._createUtoken(payload);
              case 20:
                _context20.next = 25;
                break;
              case 22:
                _context20.prev = 22;
                _context20.t1 = _context20["catch"](17);
                throwLSError({
                  payload: payload,
                  name: 'FAILED_CREATE_UTOKEN',
                  type: eventType,
                  error: _context20.t1
                });
              case 25:
                _context20.next = 45;
                break;
              case 27:
                _context20.prev = 27;
                _context20.next = 30;
                return _this6._authByUtoken(payload);
              case 30:
                _context20.next = 45;
                break;
              case 32:
                _context20.prev = 32;
                _context20.t2 = _context20["catch"](27);
                getErrorInstance({
                  payload: payload,
                  error: _context20.t2,
                  name: 'FAILED_AUTH_TO_SERVER',
                  event: eventType
                });
                _context20.next = 37;
                return setUtokenInPool({
                  uid: uid,
                  utoken: null
                });
              case 37:
                _context20.prev = 37;
                _context20.next = 40;
                return _this6._createUtoken(payload);
              case 40:
                _context20.next = 45;
                break;
              case 42:
                _context20.prev = 42;
                _context20.t3 = _context20["catch"](37);
                throwLSError({
                  payload: payload,
                  name: 'FAILED_CREATE_UTOKEN',
                  type: eventType,
                  error: _context20.t3
                });
              case 45:
                _context20.next = 47;
                return setUtokenInPool({
                  uid: uid,
                  utoken: _this6.ws.utoken
                });
              case 47:
                result = {
                  cid: _this6.ws.cid,
                  utoken: _this6.ws.utoken,
                  ls_alias: _this6.ws.lsAlias,
                  status: 'success'
                };
                resolve(result);
                _context20.next = 56;
                break;
              case 51:
                _context20.prev = 51;
                _context20.t4 = _context20["catch"](1);
                errorInstance = getErrorInstance({
                  payload: payload,
                  error: _context20.t4,
                  name: 'FAILED_AUTH',
                  event: eventType
                });
                errorInstance.name = eventType;
                reject(errorInstance);
              case 56:
              case "end":
                return _context20.stop();
            }
          }, _callee20, null, [[1, 51], [7, 12], [17, 22], [27, 32], [37, 42]]);
        }));
        return function (_x29, _x30) {
          return _ref68.apply(this, arguments);
        };
      }());
    }
    /**
     * SDK 이벤트 구독
     *
     * @memberof LivestreamManager
     * @param {Object} args  전달 인자
     * @param {string} args.path 게임 이름
     * @param {Array} [args.path_suffix] 월드(채널) 리스트
     * @param {string} [args.stream=im-game] 대상 스트림 이름
     */
  }, {
    key: "subscribe",
    value: (function () {
      var _subscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee21(_ref69) {
        var path, path_suffix, _ref69$stream, stream, eventType, payload;
        return _regeneratorRuntime().wrap(function _callee21$(_context21) {
          while (1) switch (_context21.prev = _context21.next) {
            case 0:
              path = _ref69.path, path_suffix = _ref69.path_suffix, _ref69$stream = _ref69.stream, stream = _ref69$stream === void 0 ? LS_ENUM.IM_GAME : _ref69$stream;
              eventType = WS_ENUM.EVENT.SUBSCRIBE;
              payload = {
                path: path,
                path_suffix: path_suffix,
                stream: stream
              };
              _context21.prev = 3;
              throwLSError({
                payload: {
                  status: this.status
                },
                name: 'SDK_DID_NOT_START',
                type: eventType
              });
              throwLSError({
                payload: {
                  path: path
                },
                name: 'INVALID_PATH',
                type: eventType
              });
              throwLSError({
                payload: {
                  path_suffix: path_suffix
                },
                name: 'INVALID_PATH_SUFFIX',
                type: eventType
              });
              _context21.next = 9;
              return this.ws.subscribe(payload);
            case 9:
              _context21.next = 14;
              break;
            case 11:
              _context21.prev = 11;
              _context21.t0 = _context21["catch"](3);
              getErrorInstance({
                payload: payload,
                error: _context21.t0,
                name: 'FAILED_SUBSCRIBE',
                event: eventType
              });
            case 14:
            case "end":
              return _context21.stop();
          }
        }, _callee21, this, [[3, 11]]);
      }));
      function subscribe(_x31) {
        return _subscribe.apply(this, arguments);
      }
      return subscribe;
    }()
    /**
     * SDK 이벤트 구독 취소
     *
     * @memberof LivestreamManager
     * @param {Object} args  전달 인자
     * @param {string} args.path 게임 이름
     * @param {Array} [args.path_suffix] 월드(채널) 리스트
     * @param {string} [args.stream=im-game] 대상 스트림 이름
     */
    )
  }, {
    key: "unsubscribe",
    value: (function () {
      var _unsubscribe = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee22(_ref70) {
        var path, path_suffix, _ref70$stream, stream, eventType, payload;
        return _regeneratorRuntime().wrap(function _callee22$(_context22) {
          while (1) switch (_context22.prev = _context22.next) {
            case 0:
              path = _ref70.path, path_suffix = _ref70.path_suffix, _ref70$stream = _ref70.stream, stream = _ref70$stream === void 0 ? LS_ENUM.IM_GAME : _ref70$stream;
              eventType = WS_ENUM.EVENT.UNSUBSCRIBE;
              payload = {
                path: path,
                path_suffix: path_suffix,
                stream: stream
              };
              _context22.prev = 3;
              throwLSError({
                payload: {
                  status: this.status
                },
                name: 'SDK_DID_NOT_START',
                type: eventType
              });
              throwLSError({
                payload: {
                  path: path
                },
                name: 'INVALID_PATH',
                type: eventType
              });
              throwLSError({
                payload: {
                  path_suffix: path_suffix
                },
                name: 'INVALID_PATH_SUFFIX',
                type: eventType
              });
              _context22.next = 9;
              return this.ws.unsubscribe(payload);
            case 9:
              _context22.next = 14;
              break;
            case 11:
              _context22.prev = 11;
              _context22.t0 = _context22["catch"](3);
              getErrorInstance({
                payload: payload,
                error: _context22.t0,
                name: 'FAILED_UNSUBSCRIBE',
                event: eventType
              });
            case 14:
            case "end":
              return _context22.stop();
          }
        }, _callee22, this, [[3, 11]]);
      }));
      function unsubscribe(_x32) {
        return _unsubscribe.apply(this, arguments);
      }
      return unsubscribe;
    }()
    /**
     * SDK Payload 이벤트 송신
     *
     * @memberof LivestreamManager
     * @param {Object} args  전달 인자
     * @param {bytes} args.bytes 송수신 데이터
     */
    )
  }, {
    key: "protobuf",
    value: (function () {
      var _protobuf = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee23(_ref71) {
        var bytes, eventType, payload;
        return _regeneratorRuntime().wrap(function _callee23$(_context23) {
          while (1) switch (_context23.prev = _context23.next) {
            case 0:
              bytes = _ref71.bytes;
              eventType = WS_ENUM.EVENT.PROTOBUF;
              payload = {
                bytes: bytes
              };
              _context23.prev = 3;
              throwLSError({
                payload: {
                  status: this.status
                },
                name: 'SDK_DID_NOT_START',
                type: eventType
              });
              throwLSError({
                payload: payload,
                name: 'INVALID_PAYLOAD',
                type: eventType
              });
              _context23.next = 8;
              return this.ws.sendByProtobuf(payload);
            case 8:
              _context23.next = 13;
              break;
            case 10:
              _context23.prev = 10;
              _context23.t0 = _context23["catch"](3);
              getErrorInstance({
                payload: payload,
                error: _context23.t0,
                name: 'FAILED_GET_PAYLOAD',
                event: eventType
              });
            case 13:
            case "end":
              return _context23.stop();
          }
        }, _callee23, this, [[3, 10]]);
      }));
      function protobuf(_x33) {
        return _protobuf.apply(this, arguments);
      }
      return protobuf;
    }()
    /**
     * LS SDK 종료
     *
     * @memberof LivestreamManager
     */
    )
  }, {
    key: "finalize",
    value: function finalize() {
      var eventType = LS_ENUM.INTERFACE.FINALIZE;
      try {
        SocketBox.dropLSSocket();
        this._updateModuleStatus(LS_ENUM.STATUS.STOP);
        this._setInfo();
      } catch (error) {
        throwLSError({
          error: error,
          name: 'FAILED_FIN_PROCESS',
          type: eventType
        });
      }
    }
  }, {
    key: "_asyncFinalize",
    value: function _asyncFinalize() {
      var _this25 = this;
      return new Promise(function (resolve, reject) {
        try {
          _this25.finalize();
          resolve();
        } catch (error) {
          reject(error);
        }
      });
    }
    /**
     * @memberof LivestreamManager
     * @param {string} stream 스트림 이름(ls, im ...)
     * @param {eventListenerCallback} successCB 해당 상태에 대한 내용 콜백
     * @param {eventListenerErrorCallback} failCB 에러 콜백
     * @description
     * 3rd party SDK 용 이벤트 리스너 등록<br><br>
     * https://confluence.nexon.com/pages/viewpage.action?pageId=323974479 참조
     */
  }, {
    key: "addEventListener",
    value: function addEventListener(stream, successCB, failCB) {
      try {
        if (!stream || typeof stream !== 'string') throw false;
        return SocketBox.addEventListener(stream, successCB); // return this.ws.event.addEventListener(stream, successCB)
      } catch (error) {
        var errorInstacne = getErrorInstance({
          event: LS_ENUM.INTERFACE.ADD_EVENT_LISTENER,
          payload: {
            stream: stream
          },
          name: 'FAILED_GET_LISTENER',
          error: error
        });
        return failCB(errorInstacne);
      }
    }
    /**
     * @memberof LivestreamManager
     * @param {Object} listener 등록한 리스너 객체
     * @description
     * 3rd party SDK 용 이벤트 리스너 삭제<br><br>
     * https://confluence.nexon.com/pages/viewpage.action?pageId=323974479 참조
     */
  }, {
    key: "removeEventListener",
    value: function removeEventListener(listener) {
      if (!listener) return false;
      SocketBox.removeEventListener(listener); // this.ws.event.removeEventListener(listener)

      return true;
    }
    /**
     * LS SDK 시작(소켓 연결) 상태 확인
     *
     * @memberof LivestreamManager
     */
  }, {
    key: "isStart",
    value: function isStart() {
      return this.status === LS_ENUM.STATUS.START;
    }
    /**
     * LS SDK 준비(토큰생성 - 인증) 상태 확인
     *
     * @memberof LivestreamManager
     */
  }, {
    key: "isStandby",
    value: function isStandby() {
      return this.status === LS_ENUM.STATUS.STANDBY;
    }
    /**
     * LS SDK 종료(소켓 연결 해제) 상태 확인
     *
     * @memberof LivestreamManager
     */
  }, {
    key: "isStop",
    value: function isStop() {
      return this.status === LS_ENUM.STATUS.STOP;
    }
  }]);
}();
var LSModule = new LivestreamManager();
var livestreamConnector = SDKApi(LSModule);
var infaceModule = InfaceSDK.register({
  name: 'livestream',
  version: livestreamConnector.getVersion(),
  description: 'livestream sdk for inface-sdk',
  rawApis: RawApi(LSModule),
  sdkApis: [{
    name: 'livestreamConnector',
    action: livestreamConnector
  }]
});
export default infaceModule;